{
  "checkInLocationIsOutsideThe": "You are {{0}} m de le allowed check-in area (office limit is {{1}} m). Move closer, enable precise location on votre phone, ou ask HR à verify le office coordinates et radius.",
  "checkOutLocationIsOutsideThe": "You are {{0}} m de le allowed check-out area (office limit is {{1}} m). Move closer, enable precise location on votre phone, ou ask HR à verify le office coordinates et radius.",
  "geoCheckInRequiresLatitudeAnd": "Location is requis pour geo présence. Allow location access in votre browser, turn on GPS, et try again.",
  "dashboard": {
    "title": "Tableau de bord RH",
    "payrollRuns": "Cycles de paie",
    "openPositions": "Postes ouverts",
    "employeesReady": "Employés prêts",
    "pendingAttendance": "Présence en attente",
    "pendingTimesheets": "Feuilles de temps en attente",
    "pendingAllowances": "Indemnités en attente",
    "pendingExpenses": "Dépenses en attente",
    "pendingClaims": "Demandes en attente",
    "payrollReady": "Paie prête",
    "payrollExceptions": "Exceptions paie",
    "totalPayrollCost": "Coût total paie",
    "allowanceCost": "Coût indemnités",
    "expenseCost": "Coût dépenses",
    "claimCost": "Coût demandes"
  },
  "attendance": {
    "title": "Présence et congés",
    "tabs": {
      "attendance": "Présence",
      "leave": "Congés",
      "overtime": "Heures supplémentaires"
    },
    "recordTabs": {
      "all": "Tout",
      "attendance": "Présence",
      "leave": "Congés"
    },
    "newRecord": "Nouvel enregistrement",
    "addRecord": "Ajouter un enregistrement",
    "recordType": "Type d'enregistrement",
    "aria": {
      "attendanceAndLeave": "Présence et congés"
    },
    "detail": {
      "checkIn": "Arrivée",
      "checkOut": "Départ",
      "overtime": "HS"
    },
    "status": {
      "present": "Présent",
      "absent": "Absent",
      "late": "En retard",
      "halfDay": "Demi-journée",
      "wfh": "Télétravail",
      "holiday": "Jour férié",
      "weekend": "Week-end"
    },
    "leaveStatus": {
      "pending": "En attente",
      "returned": "Renvoyé",
      "submitted": "Soumis",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "cancelled": "Annulé"
    },
    "durationMode": {
      "fullDay": "Journée complète",
      "halfDay": "Demi-journée",
      "hourly": "Horaire",
      "shift": "Équipe spécifique"
    },
    "metrics": {
      "worked": "Travaillé",
      "leave": "Congés",
      "overtime": "HS"
    },
    "actions": {
      "recordAttendance": "Enregistrer la présence",
      "createLeave": "Créer un congé",
      "checkOut": "Départ",
      "geoCheckOut": "Départ géolocalisé",
      "pendingApproval": "En attente d'approbation"
    },
    "kind": {
      "attendance": "Présence",
      "overtime": "Heures supplémentaires"
    },
    "hints": {
      "bulkAttendance": "Enregistrez la même présence pour un ou plusieurs employés.",
      "bulkLeave": "Créez la même demande de congé pour un ou plusieurs employés."
    },
    "empty": {
      "noEmployees": "Aucun employé dans votre périmètre — ajustez les filtres ou la hiérarchie."
    },
    "toast": {
      "checkOutRecorded": "Départ enregistré",
      "attendanceRecorded": "Présence enregistrée",
      "leaveCreated": "Demande de congé créée",
      "cancellationSubmitted": "Annulation soumise pour approbation",
      "leaveCancelled": "Congé annulé",
      "attendanceCancelled": "Présence annulée",
      "overtimeCancelled": "Heures sup. annulées",
      "selectEmployee": "Sélectionnez au moins un employé"
    },
    "errors": {
      "checkInRequired": "L'heure d'arrivée est requise",
      "checkOutAfterCheckIn": "Le départ doit être après l'arrivée",
      "overtimeTypeRequired": "Sélectionnez un type d'heures sup. lorsque le temps travaillé dépasse les heures prévues",
      "leaveTypeRequired": "Le type de congé et au moins un jour sont requis",
      "leaveTypeOnly": "Le type de congé est requis",
      "leaveDayRequired": "Sélectionnez au moins un jour de congé",
      "leaveReasonRequired": "Le motif du congé est obligatoire",
      "attachmentUploadFailed": "Échec du téléversement de la pièce jointe",
      "checkOutFailed": "Échec de l'enregistrement du départ",
      "markAttendanceFailed": "Échec de l'enregistrement de la présence",
      "createLeaveFailed": "Échec de la création du congé",
      "cancelFailed": "Échec de l'annulation"
    }
  },
  "payroll": {
    "title": "Paie",
    "newRun": "Nouvelle paie",
    "periodStart": "Début de période",
    "periodEnd": "Fin de période",
    "createRun": "Créer la paie",
    "workflowHint": "Flux : créer la paie → approuver → calculer. Le calcul utilise les formules de l'organisation si configurées, sinon un taux légal de secours.",
    "formulasActive": "{{count}} formule(s) active(s) : {{codes}}",
    "noFormulasFallback": "Aucune formule pays — le taux légal de secours s'appliquera",
    "calculate": "Calculer",
    "calculateUsingFormulas": "Calculer avec {{count}} formule(s)",
    "calculateStatutoryFallback": "Calculer avec le taux légal de secours",
    "approveBeforeCalculate": "Approuvez cette paie avant de calculer",
    "inStatutory": "Déclarations IN",
    "bankFile": "Fichier bancaire",
    "transactions": "Transactions",
    "transactionsModalTitle": "Transactions de paie",
    "transactionsModalTitleRun": "Transactions — {{runCode}}"
  },
  "leave": {
    "title": "Congés",
    "request": "Demander un congé",
    "balance": "Solde de congés"
  },
  "calendar": {
    "granularity": {
      "year": "Année",
      "month": "Mois",
      "week": "Semaine",
      "day": "Jour"
    },
    "timeDisplay": {
      "hours": "Heures",
      "days": "Jours",
      "both": "Les deux"
    },
    "weekNumber": "Semaine {{n}}",
    "weekShortPrefix": "S{{n}} · ",
    "employee": "Employé",
    "expected": "Prévu",
    "totalHours": "Total h",
    "noEmployees": "Aucun employé à afficher",
    "legend": {
      "workingDay": "Jour ouvré",
      "halfDay": "Demi-journée",
      "offDay": "Jour de repos",
      "holiday": "Jour férié",
      "special": "Spécial",
      "worked": "Travaillé",
      "leave": "Congé",
      "overtime": "HS",
      "pendingApproval": "En attente d'approbation"
    },
    "units": {
      "hoursCount": "{{value}} h",
      "dayCountOne": "{{value}} jour",
      "dayCountOther": "{{value}} jours",
      "hrsSuffix": "(h)",
      "daysSuffix": "(jours)"
    },
    "metricHeaderHours": "{{label}} (h)",
    "metricHeaderDays": "{{label}} (jours)",
    "marker": {
      "present": "Pr",
      "overtime": "HS",
      "leaveFallback": "C"
    },
    "tooltip": {
      "workedApproved": "Travaillé (approuvé)",
      "workedPending": "Travaillé (en attente)",
      "workedRejected": "Travaillé (refusé)",
      "workedCancelled": "Travaillé (annulé)",
      "leaveApproved": "Congé (approuvé)",
      "leavePending": "Congé (en attente)",
      "leaveRejected": "Congé (refusé)",
      "leaveCancelled": "Congé (annulé)",
      "overtimeApproved": "HS (approuvé)",
      "overtimePending": "HS (en attente)",
      "overtimeRejected": "HS (refusé)",
      "overtimeCancelled": "HS (annulé)",
      "fromAttendance": "depuis la présence",
      "manualRequest": "demande manuelle",
      "punches": "({{count}} pointages)",
      "late": "retard {{minutes}}",
      "leaveTypeFallback": "Congé",
      "fullDay": "journée complète"
    },
    "overtimeMinutesLabel": "{{minutes}} {{abbrev}}",
    "overtimeBadge": "{{abbrev}} {{status}}",
    "pendingOvertimeTrend": "{{minutes}} {{abbrev}} {{label}}"
  },
  "columns": {
    "code": "Code",
    "name": "Nom",
    "status": "Statut",
    "actions": "Opérations",
    "description": "Descriptif",
    "color": "Couleur",
    "employee": "Employé",
    "shift": "Quart",
    "hours": "Heures",
    "days": "Jours",
    "type": "Catégorie",
    "date": "Date",
    "title": "Titre",
    "category": "Catégorie",
    "provider": "Fournisseur",
    "active": "Actif",
    "location": "Lieu",
    "email": "E-mail",
    "role": "Rôle",
    "amount": "Montant",
    "comments": "Commentaires",
    "level": "Niveau",
    "grade": "Échelon",
    "start": "Début",
    "end": "Fin",
    "score": "Score",
    "reason": "Motif",
    "content": "Contenu",
    "rating": "Note",
    "reviewer": "Évaluateur",
    "cycle": "Cycle",
    "details": "Détails",
    "expiry": "Expiration",
    "download": "Télécharger",
    "claim": "Note de frais",
    "from": "Du",
    "to": "Au",
    "run": "Paie",
    "gross": "Brut",
    "net": "Net",
    "product": "Produit",
    "revenue": "Revenu",
    "payment": "Paiement",
    "invoiceNumber": "Facture n°",
    "quantitySold": "Qté vendue",
    "rate": "Taux %",
    "taxable": "Imposable",
    "tax": "Taxe",
    "lines": "Lignes",
    "alertQty": "Qté alerte",
    "need": "Besoin",
    "daysLeft": "Jours restants",
    "invoices": "Factures",
    "sales": "Ventes",
    "organization": "Organisation",
    "platforms": "Plateformes",
    "paid": "Payé",
    "carryForward": "Report",
    "entitlement": "Droit",
    "used": "Utilisé",
    "pending": "En attente",
    "available": "Disponible",
    "payrollMode": "Mode de paie",
    "hoursPerDay": "Heures/jour",
    "endDateRequired": "Date de fin requise",
    "trackExpiry": "Suivre l'expiration",
    "receiptRequired": "Reçu requis",
    "leaveType": "Type de congé",
    "policy": "Politique",
    "annualDays": "Jours annuels",
    "accrual": "Acquisition",
    "maxConsecutive": "Max consécutif",
    "carryForwardMax": "Report max",
    "backdated": "Antidaté",
    "nonWorking": "Journée de congé",
    "workingDays": "Jours ouvrés",
    "defaultHours": "Heures par défaut",
    "employment": "Emploi",
    "headcount": "Effectif",
    "positions": "Postes",
    "position": "Poste",
    "relationship": "Relation",
    "grossAmount": "Montant brut",
    "effectiveFrom": "En vigueur à partir du",
    "effectiveTo": "En vigueur jusqu'au",
    "salaryStructure": "Structure salariale",
    "structureName": "Nom de structure",
    "applicableDay": "Jour applicable",
    "netAmount": "Montant net",
    "employeeId": "ID employé",
    "deductions": "Déductions",
    "mode": "Mode",
    "inOut": "Entrée / sortie",
    "open": "Ouvert",
    "ot": "HS",
    "worked": "Travaillé",
    "week": "Semaine",
    "course": "Formation",
    "tag": "Étiquette",
    "nonWorkingDay": "Journée de congé",
    "returnRequired": "Retour requis",
    "threshold": "Seuil",
    "dailyOt": "HS journalières",
    "weeklyOt": "HS hebdomadaires",
    "billable": "Facturable",
    "dayType": "Type de jour",
    "overallOtApproved": "HS totales (approuvées)",
    "aggregateWeeklyOtCompany": "Agréger les HS hebdomadaires (société)",
    "requiredDocument": "Document requis",
    "payRun": "Paie"
  },
  "ess": {
    "tabs": {
      "home": "Accueil",
      "profile": "Profil",
      "schedule": "Planning",
      "time": "Temps",
      "leave": "Congés",
      "pay": "Paie",
      "approvals": "Mes demandes"
    },
    "actions": {
      "refresh": "Actualiser",
      "manualCheckOut": "Départ manuel",
      "geoCheckIn": "Arrivée géolocalisée",
      "geoCheckOut": "Départ géolocalisé",
      "updating": "Mise à jour…",
      "openApprovalInbox": "Ouvrir la boîte d'approbation",
      "submitLeaveRequest": "Soumettre une demande de congé",
      "updateDocuments": "Mettre à jour les documents",
      "timeAndAttendance": "Temps et présence",
      "fullSchedule": "Planning complet",
      "fullRoster": "Planning complet →",
      "viewCalendar": "Voir le calendrier →",
      "viewTimeTab": "Onglet Temps →",
      "viewLeaveTab": "Onglet Congés →",
      "viewPayTab": "Onglet Paie →",
      "viewRequestsTab": "Onglet Demandes →",
      "viewProfileTab": "Profil →",
      "downloadPayslipAria": "Télécharger la fiche de paie pour la paie {{runCode}}"
    },
    "home": {
      "todayAtWork": "Aujourd'hui au travail",
      "scheduleLoadsFromShifts": "Le planning est chargé à partir de vos quarts assignés et du planning.",
      "manualCheckInOpen": "Arrivée manuelle {{time}} · session ouverte",
      "geoCheckInOpen": "Arrivée géolocalisée {{time}} · session ouverte",
      "expectedHoursMonth": "Heures prévues (mois)",
      "workedHoursApproved": "Heures travaillées (approuvées)",
      "overtimeApproved": "Heures supplémentaires (approuvées)",
      "shiftAssignments": "Affectations de quarts",
      "companyDefault": "Par défaut de l'entreprise",
      "loadingRoster": "Chargement du planning…",
      "loading": "Chargement…",
      "requested": "{{days}} demandé(s)",
      "netAmount": "Net {{amount}}",
      "amountLabel": "Montant {{amount}}",
      "openSession": "Ouvert",
      "workflow": "Flux de travail"
    },
    "documentTracking": {
      "title": "Suivi des documents",
      "description": "Certains documents requis nécessitent votre attention. Téléversez-les ou renouvelez-les pour rester conforme."
    },
    "leave": {
      "calendarHint": "Cliquez ou faites glisser sur les jours pour sélectionner. Seuls les jours choisis sont inclus — les écarts sont conservés.",
      "scheduledLeave": "Congé planifié",
      "calculatingLeaveImpact": "Calcul de l'impact des congés…"
    },
    "time": {
      "pendingItemsNote": "Les éléments en attente sont affichés séparément et comptent pour l'approbation avant d'être inclus dans les totaux ci-dessus.",
      "manualSessionOpen": "Session manuelle ouverte depuis {{time}}",
      "geoSessionOpen": "Session géolocalisée ouverte depuis {{time}}",
      "modeGeo": "Géo",
      "modeManual": "Manuel"
    },
    "schedule": {
      "rangeDescription": "Planning prévu et résolu du {{start}} au {{end}}"
    },
    "approvals": {
      "returnedForChanges_one": "{{count}} demande renvoyée pour modification.",
      "returnedForChanges_other": "{{count}} demandes renvoyées pour modification.",
      "noApprovalRequestsYet": "Aucune demande d'approbation pour l'instant."
    },
    "errors": {
      "geoCheckInFailed": "Impossible de check in — you may be outside the office area. Allow location access, move closer, or ask HR to verify the attendance location settings.",
      "geoCheckOutFailed": "Impossible de check out — you may be outside the office area. Allow location access, move closer, or ask HR to verify the attendance location settings."
    },
    "empty": {
      "noOpenAttendanceSession": "Aucune session de présence ouverte",
      "noUpcomingRoster": "Aucune entrée de planning à venir — le quart assigné ou le calendrier de l'entreprise s'applique.",
      "noRosterThisMonth": "Aucune entrée de planning ce mois-ci.",
      "noAttendanceRecords": "Aucun enregistrement de présence.",
      "noLeaveRequests": "Aucune demande de congé.",
      "noPayslips": "Aucune fiche de paie disponible.",
      "noApprovalRequests": "Aucune demande d'approbation.",
      "noOvertimeThisMonth": "Aucune demande d'heures supplémentaires ce mois-ci.",
      "noExpenseClaims": "Aucune note de frais.",
      "noTrainingAssignments": "Aucune formation assignée."
    }
  },
  "mss": {
    "loading": "Chargement…",
    "stats": {
      "directReports": "Collaborateurs directs",
      "pendingLeave": "Congés en attente",
      "pendingAttendance": "Présences en attente",
      "myApprovalQueue": "Ma file d'approbation"
    },
    "teamHierarchy": {
      "title": "Ma hiérarchie d'équipe",
      "hint": "Cliquez sur un employé pour ouvrir son profil"
    },
    "quickActions": {
      "title": "Actions rapides",
      "myApprovals": "Mes approbations",
      "timeAttendance": "Temps et présence",
      "allEmployees": "Tous les employés"
    },
    "actions": {
      "refresh": "Actualiser"
    }
  },
  "hierarchy": {
    "noReportingHierarchy": "Aucune hiérarchie de reporting",
    "assignManagersToBuild": "Assignez des managers pour construire votre organigramme.",
    "you": "Vous",
    "viewOnly": "Lecture seule",
    "directReport_one": "{{count}} collaborateur direct",
    "directReport_other": "{{count}} collaborateurs directs",
    "employeesInTree_one": "{{count}} employé dans l'arbre",
    "employeesInTree_other": "{{count}} employés dans l'arbre",
    "expandAll": "Tout développer",
    "collapseAll": "Tout réduire",
    "expandAria": "Développer {{name}}",
    "collapseAria": "Réduire {{name}}",
    "orgChart": {
      "title": "Organigramme",
      "description": "Arbre de reporting de l'entreprise. Vous pouvez ouvrir les profils complets pour vous-même et votre équipe ; les managers et pairs hors périmètre affichent un aperçu limité uniquement.",
      "loading": "Chargement de la hiérarchie…",
      "empty": "Aucun employé dans l'arbre de reporting. Assignez un manager ou assurez-vous que les employés sont actifs et liés à cette société.",
      "summaryWithViewer": "{{count}} employés · organigramme complet — vous pouvez ouvrir les profils pour vous-même et votre équipe",
      "summaryTopDown": "{{count}} employés · arbre de reporting descendant"
    },
    "reportingRelationship": {
      "title": "Ligne de reporting",
      "description": "Définir, modifier ou supprimer le manager direct d'un employé. Choisissez « Aucun manager » pour effacer une ligne de reporting invalide ou obsolète.",
      "noManager": "Aucun manager"
    },
    "actions": {
      "employeeDirectory": "Répertoire des employés",
      "orgMasterData": "Données de référence org."
    },
    "preview": {
      "limitedTitle": "Aperçu employé limité",
      "managerTitle": "Manager hiérarchique",
      "limitedDescription": "Cette personne est visible dans la hiérarchie, mais les détails complets du profil RH ne sont disponibles que pour vous-même et les employés de votre ligne de reporting en dessous de vous.",
      "managerDescription": "Il s'agit de votre manager direct. Les détails complets du profil RH ne sont pas disponibles depuis cette vue."
    },
    "errors": {
      "failedToAssignManager": "Échec de l'assignation du manager",
      "failedToRemoveManager": "Échec de la suppression du manager"
    }
  },
  "directory": {
    "loadingEmployees": "Chargement des employés…",
    "employeesFound_one": "{{count}} employé trouvé",
    "employeesFound_other": "{{count}} employés trouvés",
    "noSearchResults": "Aucun employé ne correspond à votre recherche",
    "tryDifferentSearch": "Essayez un autre terme de recherche.",
    "hierarchySidebarHint": "Tous les employés de l'entreprise sont listés. Ouvrez les profils complets pour vous-même et votre équipe ; les autres affichent un aperçu limité.",
    "detailTabs": {
      "overview": "Vue d'ensemble",
      "employment": "Emploi",
      "time": "Temps et congés",
      "pay": "Paie et performance",
      "documents": "Documents et formation"
    },
    "actions": {
      "shifts": "Équipes",
      "timeAttendance": "Temps et présence",
      "overtime": "Heures supplémentaires",
      "editEmployment": "Modifier l'emploi",
      "recordLifecycleEvent": "Enregistrer un événement de cycle de vie"
    },
    "lifecycle": {
      "noEvents": "Aucun événement de cycle de vie enregistré.",
      "present": "présent"
    },
    "training": {
      "noRecords": "Aucune formation enregistrée."
    },
    "assets": {
      "noAssigned": "Aucun actif assigné."
    }
  },
  "overtimePage": {
    "newRequest": "Nouvelle demande d'heures supplémentaires",
    "requestsList": "Demandes d'heures supplémentaires",
    "bulkHint": "Demander la même entrée d'heures supplémentaires pour un ou plusieurs employés.",
    "selectEmployeeForSummary": "Sélectionnez un employé pour voir le total des heures supplémentaires approuvées sur la période choisie.",
    "emptyWithCreate": "Modifiez l'employé ou la plage de dates, ou soumettez une nouvelle demande ci-dessus.",
    "emptyFilterOnly": "Modifiez l'employé ou la plage de dates.",
    "toast": {
      "requested": "Demande d'heures supplémentaires envoyée",
      "selectEmployee": "Sélectionnez au moins un employé"
    },
    "approval": {
      "cancellationPending": "Annulation en attente d'approbation",
      "cancellationPendingShort": "annulation en attente"
    },
    "summaryDateRange": " · {{from}} au {{to}}",
    "typeModal": {
      "editTitle": "Modifier le type d'heures supplémentaires",
      "newTitle": "Nouveau type d'heures supplémentaires"
    },
    "attendanceFields": {
      "title": "Heures supplémentaires",
      "estimatedWithType": "Heures supplémentaires estimées : {{estimated}} (prévu {{expected}}). Sélectionnez le type d'heures supplémentaires avant d'enregistrer.",
      "expectedBeyondSchedule": "Heures prévues pour ce jour : {{expected}}. Sélectionnez un type d'heures supplémentaires si l'employé a travaillé au-delà du planning."
    },
    "modal": {
      "title": "Heures supplémentaires",
      "titleLeaveDay": "Heures supplémentaires (jour de congé)",
      "approved": "Approuvé {{minutes}}",
      "pendingApproval": "{{minutes}} en attente d'approbation"
    }
  },
  "devicesPage": {
    "deviceTypes": {
      "biometric": "Biométrique",
      "rfid": "RFID",
      "qr": "QR",
      "face": "Reconnaissance faciale"
    },
    "noDevices": "Aucun appareil enregistré."
  },
  "compensationPage": {
    "salaryStructures": "Structures salariales",
    "assignToEmployee": "Affecter à un employé",
    "structureFallback": "Structure n°{{id}}",
    "selectEmployeeToViewAssignments": "Sélectionnez un employé pour voir ses affectations salariales.",
    "assignmentsForEmployee": "Affectations salariales"
  },
  "statutoryPage": {
    "portals": {
      "epfo": {
        "name": "EPFO (ECR)",
        "description": "Fonds de prévoyance des employés — téléversement mensuel ECR"
      },
      "esic": {
        "name": "ESIC",
        "description": "Déclaration des cotisations d'assurance sociale des employés"
      },
      "traces": {
        "name": "TRACES (TDS)",
        "description": "Portail de rapprochement TDS / formulaire 24Q"
      }
    },
    "payrollRunsSection": "Paies — export et dépôt automatique",
    "downloadCsv": "Télécharger CSV",
    "filePortal": "Déposer {{portal}}",
    "refreshStatus": "Actualiser le statut",
    "noPayrollRuns": "Aucune paie pour le moment",
    "filingFailed": "Échec du dépôt {{portalCode}}"
  },
  "loansPage": {
    "newLoanRequest": "Nouvelle demande de prêt",
    "submitRequest": "Soumettre la demande"
  },
  "master": {
    "title": "Données de référence RH",
    "description": "Configurez les référentiels RH par société — congés, emploi, organisation, documents, heures sup., équipes et dépenses.",
    "add": "Ajouter {{label}}",
    "loadFailed": "Échec du chargement des données de référence RH",
    "yes": "Oui",
    "no": "Non",
    "tabs": {
      "leave": {
        "label": "Types de congés",
        "description": "Catégories de congés, couleurs calendrier et politiques d'acquisition par société"
      },
      "employment": {
        "label": "Types d'emploi",
        "description": "Types de contrat utilisés à l'embauche et aux changements d'emploi"
      },
      "documents": {
        "label": "Types de documents",
        "description": "Catégories pour les documents employés et le suivi d'expiration"
      },
      "businessUnits": {
        "label": "Unités commerciales",
        "description": "Divisions de premier niveau pour regrouper départements et reporting"
      },
      "departments": {
        "label": "Départements",
        "description": "Équipes fonctionnelles — parent et unité commerciale optionnels"
      },
      "grades": {
        "label": "Grades",
        "description": "Niveaux pour les grilles de rémunération et les intitulés"
      },
      "designations": {
        "label": "Intitulés",
        "description": "Titres de poste liés à un département et un grade"
      },
      "overtime": {
        "label": "Types d'heures sup.",
        "description": "Classification des heures sup. par contexte calendrier — par société"
      },
      "shiftTypes": {
        "label": "Types d'équipe",
        "description": "Catégories pour les définitions d'équipes (fixe, flexible, rotation, etc.)"
      },
      "shifts": {
        "label": "Définitions d'équipes",
        "description": "Équipes nommées avec horaires et couleurs calendrier pour l'affectation"
      },
      "expenseTypes": {
        "label": "Types de dépenses",
        "description": "Catégories pour les notes de frais et remboursements"
      },
      "assetTypes": {
        "label": "Actif types",
        "description": "Equipment categories employés can request — laptop, phone, monitor, etc."
      },
      "assetRequests": {
        "label": "Demandes d'actifs",
        "description": "Submit et track employé equipment requests avec approbation flux de travail"
      },
      "pipelineStages": {
        "label": "Étapes du pipeline",
        "description": "Colonnes kanban recrutement — nom, ordre et couleur par société"
      }
    },
    "payrollMode": {
      "monthlySalary": "Salaire mensuel",
      "hourly": "Horaire",
      "contractRules": "Règles contractuelles"
    },
    "dayClass": {
      "any": "Tout jour",
      "working": "Jour ouvré planifié",
      "holiday": "Jour férié",
      "weekend": "Week-end / jour de repos"
    },
    "shifts": {
      "title": "Définitions d'équipes",
      "description": "Équipes nommées avec type, horaires et couleur — utilisées sur la page Équipes.",
      "shiftName": "Nom de l'équipe",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "calendarColor": "Couleur calendrier",
      "createShift": "Créer l'équipe",
      "empty": "Aucune équipe — créez-en une ci-dessus",
      "loadFailed": "Échec du chargement des équipes",
      "createFailed": "Échec de la création de l'équipe",
      "deactivateFailed": "Échec de la désactivation de l'équipe",
      "activateFailed": "Échec de l'activation de l'équipe"
    },
    "leavePolicy": {
      "saved": "Politique de congés enregistrée — soldes mis à jour selon l'acquisition",
      "saveFailed": "Échec de l'enregistrement de la politique"
    },
    "modals": {
      "leaveType": {
        "edit": "Modifier le type de congé",
        "new": "Nouveau type de congé"
      },
      "employmentType": {
        "edit": "Modifier le type d'emploi",
        "new": "Nouveau type d'emploi"
      },
      "documentType": {
        "edit": "Modifier le type de document",
        "new": "Nouveau type de document"
      },
      "shiftType": {
        "edit": "Modifier le type de quart",
        "new": "Nouveau type de quart"
      },
      "expenseType": {
        "edit": "Modifier le type de dépense",
        "new": "Nouveau type de dépense"
      },
      "assetType": {
        "edit": "Edit actif type",
        "new": "New actif type"
      },
      "pipelineStage": {
        "edit": "Modifier l'étape du pipeline",
        "new": "Nouvelle étape du pipeline"
      },
      "calendarColor": "Couleur du calendrier",
      "calendarColorHint": "Utilisée sur le calendrier de présence et les listes de congés.",
      "documentExpiryYes": "Oui — exiger pièce d'identité, nom, expiration et fichier",
      "pipelineStageCodeLocked": "Les codes d'étapes intégrés ne peuvent pas être modifiés. Vous pouvez les renommer et changer leur couleur."
    },
    "leavePolicyPanel": {
      "title": "Politiques de congés",
      "description": "Les types de congés payés nécessitent une politique. Les congés non payés sont illimités sauf si vous configurez une politique pour limiter les jours ou ajouter des règles. Les changements d'acquisition mettent à jour automatiquement les soldes des employés.",
      "configurePolicy": "Configurer la politique",
      "editTitle": "Modifier la politique de congés",
      "configureTitle": "Configurer la politique de congés",
      "optional": "Facultatif",
      "required": "Requis",
      "notRequired": "Non requis",
      "annualEntitlementHint": "Nombre total de jours par an — modifier ceci met à jour tous les soldes des employés",
      "backdatedNo": "Non — la date de début doit être aujourd'hui ou ultérieure",
      "backdatedYes": "Oui — les employés peuvent demander des dates passées",
      "statusActive": "Actif",
      "statusInactive": "Inactif",
      "accrual": {
        "none": "Pas d'acquisition",
        "monthly": "Mensuel",
        "yearly": "Annuel (forfait)",
        "monthlyWithDays": "Mensuel ({{days}} j)",
        "yearlyLump": "Forfait annuel"
      },
      "backdated": {
        "no": "Non",
        "yesAny": "Oui (toute date passée)",
        "yesUpTo": "Oui (jusqu'à {{days}} jours)"
      },
      "defaultPolicyName": "Politique {{name}}"
    },
    "orgMaster": {
      "gradesHintBefore": "Configurez d'abord les",
      "gradesHintLink": "grades",
      "gradesHintAfter": "avant les désignations pour que les intitulés héritent du bon niveau.",
      "modals": {
        "businessUnit": {
          "edit": "Modifier l'unité commerciale",
          "add": "Ajouter une unité commerciale"
        },
        "department": {
          "edit": "Modifier le département",
          "add": "Ajouter un département"
        },
        "grade": {
          "edit": "Modifier le grade",
          "add": "Ajouter un grade"
        },
        "designation": {
          "edit": "Modifier la désignation",
          "add": "Ajouter une désignation"
        }
      },
      "createFailed": "Échec de la création de {{entity}}"
    },
    "toast": {
      "leaveTypeDeactivated": "Type de congé désactivé",
      "leaveTypeActivated": "Type de congé activé",
      "leaveTypeUpdated": "Type de congé mis à jour",
      "leaveTypeCreated": "Type de congé créé",
      "employmentTypeDeactivated": "Type d'emploi désactivé",
      "employmentTypeActivated": "Type d'emploi activé",
      "employmentTypeUpdated": "Type d'emploi mis à jour",
      "employmentTypeCreated": "Type d'emploi créé",
      "documentTypeDeactivated": "Type de document désactivé",
      "documentTypeActivated": "Type de document activé",
      "documentTypeUpdated": "Type de document mis à jour",
      "documentTypeCreated": "Type de document créé",
      "overtimeTypeDeactivated": "Type d'heures sup. désactivé",
      "overtimeTypeActivated": "Type d'heures sup. activé",
      "overtimeTypeUpdated": "Type d'heures sup. mis à jour",
      "overtimeTypeCreated": "Type d'heures sup. créé",
      "shiftTypeDeactivated": "Type d'équipe désactivé",
      "shiftTypeActivated": "Type d'équipe activé",
      "shiftTypeUpdated": "Type d'équipe mis à jour",
      "shiftTypeCreated": "Type d'équipe créé",
      "shiftCreated": "Équipe créée",
      "shiftDeactivated": "Équipe désactivée",
      "shiftActivated": "Équipe activée",
      "expenseTypeDeactivated": "Type de dépense désactivé",
      "expenseTypeActivated": "Type de dépense activé",
      "expenseTypeUpdated": "Type de dépense mis à jour",
      "expenseTypeCreated": "Type de dépense créé",
      "assetTypeDeactivated": "Asset type désactivé",
      "assetTypeActivated": "Asset type activé",
      "assetTypeUpdated": "Asset type mis à jour",
      "assetTypeCreated": "Asset type créé",
      "pipelineStageDeactivated": "Étape du pipeline désactivée",
      "pipelineStageActivated": "Étape du pipeline activée",
      "pipelineStageUpdated": "Étape du pipeline mise à jour",
      "pipelineStageCreated": "Étape du pipeline créée",
      "businessUnitActivated": "Unité commerciale activée",
      "businessUnitDeactivated": "Unité commerciale désactivée",
      "businessUnitUpdated": "Unité commerciale mise à jour",
      "businessUnitCreated": "Unité commerciale créée",
      "departmentActivated": "Département activé",
      "departmentDeactivated": "Département désactivé",
      "departmentUpdated": "Département mis à jour",
      "departmentCreated": "Département créé",
      "gradeActivated": "Grade activé",
      "gradeDeactivated": "Grade désactivé",
      "gradeUpdated": "Grade mis à jour",
      "gradeCreated": "Grade créé",
      "designationActivated": "Intitulé activé",
      "designationDeactivated": "Intitulé désactivé",
      "designationUpdated": "Intitulé mis à jour",
      "designationCreated": "Intitulé créé"
    },
    "errors": {
      "nameCodeRequired": "Le nom et le code sont requis",
      "shiftNameTypeRequired": "Le nom et le type d'équipe sont requis",
      "deactivateLeaveType": "Échec de la désactivation du type de congé",
      "activateLeaveType": "Échec de l'activation du type de congé",
      "deactivateEmploymentType": "Échec de la désactivation du type d'emploi",
      "activateEmploymentType": "Échec de l'activation du type d'emploi",
      "deactivateDocumentType": "Échec de la désactivation du type de document",
      "activateDocumentType": "Échec de l'activation du type de document",
      "deactivateOvertimeType": "Échec de la désactivation du type d'heures sup.",
      "activateOvertimeType": "Échec de l'activation du type d'heures sup.",
      "deactivateShiftType": "Échec de la désactivation du type d'équipe",
      "activateShiftType": "Échec de l'activation du type d'équipe",
      "deactivateExpenseType": "Échec de la désactivation du type de dépense",
      "activateExpenseType": "Échec de l'activation du type de dépense",
      "deactivateAssetType": "Échec : deactivate asset type",
      "activateAssetType": "Échec : activate asset type",
      "deactivatePipelineStage": "Échec de la désactivation de l'étape du pipeline",
      "activatePipelineStage": "Échec de l'activation de l'étape du pipeline"
    }
  },
  "recruitment": {
    "title": "Recrutement",
    "loadDashboardFailed": "Échec du chargement du tableau de bord recrutement",
    "tabs": {
      "dashboard": {
        "label": "Tableau de bord",
        "hint": "Indicateurs, entonnoir et analyses de recrutement"
      },
      "workqueue": {
        "label": "File de travail",
        "hint": "Entretiens, offres, documents et confirmations en attente"
      },
      "planning": {
        "label": "Planification effectifs",
        "hint": "Demandes d'effectifs"
      },
      "requisitions": {
        "label": "Demandes de poste",
        "hint": "Postes approuvés à pourvoir"
      },
      "jobs": {
        "label": "Offres d'emploi",
        "hint": "Postes ouverts aux candidatures"
      },
      "pipeline": {
        "label": "Pipeline",
        "hint": "Kanban candidats par étape"
      }
    },
    "hiringProgress": {
      "title": "Progression du recrutement",
      "terminalStage": "Étape terminale : {{stage}}",
      "steps": {
        "screening": "Présélection",
        "assessment": "Évaluation",
        "interview": "Entretien",
        "selection": "Sélection",
        "offer": "Offre",
        "acceptance": "Acceptation",
        "preboarding": "Pré-intégration",
        "onboarding": "Intégration",
        "hire": "Employé"
      },
      "hints": {
        "terminal": "Ce candidat n'est plus dans le flux de recrutement actif.",
        "screening": "Lancez la présélection automatique, planifiez l'évaluation, puis planifiez un entretien.",
        "interviewScheduled": "Terminez l'entretien pour passer le candidat en sélectionné.",
        "interviewed": "Le candidat doit passer en sélectionné une fois l'entretien terminé.",
        "selectionPending": "Approuvez la sélection, puis créez la lettre d'offre.",
        "selected": "Créez et envoyez la lettre d'offre.",
        "offerPending": "Approuvez l'offre, puis acceptez au nom du candidat ou partagez le lien du portail.",
        "offerSent": "Acceptez l'offre pour démarrer la pré-intégration et la vérification des antécédents.",
        "preboarding": "Terminez la checklist de pré-intégration et la vérification des antécédents ; l'intégration démarrera automatiquement.",
        "offerAccepted": "La pré-intégration démarre — complétez les documents dans le portail candidat.",
        "onboarding": "Terminez toutes les tâches d'intégration, approuvez l'intégration, puis créez le dossier employé.",
        "hired": "Employé créé — terminez l'évaluation de période d'essai à l'échéance.",
        "default": "Continuez le flux de recrutement."
      }
    },
    "errors": {
      "titleEmploymentRequired": "Le titre et le type d'emploi sont requis",
      "candidateNameRequired": "Le nom du candidat est requis",
      "titleRequired": "Le titre est requis",
      "interviewDateRequired": "La date et l'heure de l'entretien sont requises",
      "employmentTypeRequired": "Le type d'emploi est requis",
      "possibleDuplicate": "Doublon possible : {{name}}",
      "loadCandidateFailed": "Échec du chargement du candidat",
      "hireFailed": "Échec de l'embauche — terminez l'offre, la pré-intégration et l'intégration"
    },
    "toast": {
      "submittedForApproval": "Soumis pour approbation",
      "jobPostingCreated": "Offre d'emploi créée",
      "requisitionCreated": "Demande de poste créée — soumettez pour approbation depuis le tableau",
      "candidateAdded": "Candidat ajouté",
      "manpowerSubmitted": "Demande d'effectifs soumise pour approbation",
      "employeeCreated": "Employé n°{{id}} créé",
      "alreadyHired": "Déjà embauché comme employé n°{{id}}",
      "interviewScheduled": "Entretien planifié",
      "interviewCompleted": "Entretien terminé — candidat sélectionné",
      "offerCreated": "Offre créée — en attente d'approbation avant acceptation",
      "assessmentRecorded": "Évaluation enregistrée",
      "offerAccepted": "Offre acceptée — pré-intégration démarrée",
      "offerDeclined": "Offre refusée",
      "preboardingComplete": "Pré-intégration terminée — passage à l'intégration",
      "onboardingApproved": "Intégration approuvée — prêt à embaucher",
      "selectionApproved": "Sélection approuvée — vous pouvez créer l'offre",
      "offerApproved": "Offre approuvée — prête à accepter",
      "autoScreeningCompleted": "Présélection automatique terminée",
      "probationConfirmed": "Période d'essai confirmée",
      "probationExtended": "Période d'essai prolongée",
      "bgvCompleted": "Vérification des antécédents terminée"
    }
  },
  "toast": {
    "appraisalCycleCreated": "Appraisal cycle créé",
    "reviewSubmitted": "Review soumis",
    "assetRequestSubmitted": "Asset request soumis",
    "applicationSubmitted": "Application soumis",
    "expenseClaimCreated": "Expense claim créé",
    "structureCreated": "Structure créée",
    "salaryAssigned": "Salaire affecté",
    "documentUploaded": "Document téléversé",
    "bankDetailsSaved": "Bank details enregistré",
    "employmentDetailsSaved": "Employment details enregistré",
    "holidayTypeUpdated": "Holiday type mis à jour",
    "holidayTypeCreated": "Holiday type créé",
    "holidayTypeDeactivated": "Jour férié type désactivé",
    "holidayTypeActivated": "Jour férié type activé",
    "weekPatternUpdated": "Week pattern mis à jour",
    "weekPatternCreated": "Week pattern créé",
    "weekPatternDeactivated": "Week pattern désactivé",
    "weekPatternActivated": "Week pattern activé",
    "lifecycleEventRecorded": "Lifecycle event enregistré",
    "geoCheckOutRecorded": "Geo check-out enregistré",
    "geoCheckInRecorded": "Geo check-in enregistré",
    "manualCheckOutRecorded": "Manual check-out enregistré",
    "leaveRequestSubmitted": "Leave request soumis",
    "360FeedbackInvitationsSent": "Invitations de feedback 360 envoyées",
    "holidayUpdated": "Holiday mis à jour",
    "holidayAdded": "Jour férié ajoutered",
    "holidayRemoved": "Jour férié removed",
    "onboardingStarted": "Intégration démarrée",
    "exitInitiated": "Départ initié",
    "exitFinalized": "Départ finalisé",
    "loanRequestSubmitted": "Loan request soumis",
    "managerRemoved": "Responsable removed",
    "reportingRelationshipSaved": "Reporting relationship enregistré",
    "payrollRunCreated": "Payroll run créé",
    "payrollCalculatedAndProcessed": "Paie calculated et processed",
    "statutoryReportExported": "Statutory rapport exported",
    "setupSeededSuccessfully": "Configuration seeded successfully",
    "shiftUpdated": "Shift mis à jour",
    "shiftDayUpdated": "Shift enregistré pour ce jour",
    "shiftDayCleared": "Shift supprimé pour ce jour",
    "shiftChangeCancelled": "Shift change annulé",
    "statutoryCsvDownloaded": "CSV réglementaire téléchargé",
    "planCreated": "Plan créé",
    "courseCreated": "Course créé",
    "trainingAssigned": "Formation assigned",
    "travelRequestSubmitted": "Travel request soumis",
    "overrideRemoved": "Dérogation supprimée",
    "weeklyOvertimeRecalculated": "Heures supplémentaires hebdomadaires recalculées",
    "monthEndWorkforceProcessCompleted": "Month-end workforce process terminé",
    "portalFiling": "Déclaration {{portalCode}} {{status}} — réf. {{ref}}",
    "reportExported": "{{reportType}} exporté",
    "deviceRegistered": "Appareil enregistré. Clé API : {{apiKey}}",
    "weeklyOtAggregated": "Heures supp. hebdo agrégées pour {{count}} employés",
    "hiringPolicySaved": "Politique d'embauche enregistrée pour {{company}}",
    "approvalPolicySaved": "Politique d'approbation enregistrée pour {{company}}",
    "bankDetailsSubmittedForApproval": "Coordonnées bancaires soumises pour approbation",
    "travelRequestSettled": "Demande de déplacement réglée."
  },
  "errors": {
    "failedToLoadFieldPermissions": "Échec du chargement de field permissions",
    "failedToLoadCountryPacks": "Échec du chargement de country packs",
    "failedToLoadShiftRotations": "Échec du chargement de shift rotations",
    "selectACycleAndEmployee": "Sélectionnez un cycle and employee",
    "failedToLoadAppraisalCycles": "Échec du chargement de appraisal cycles",
    "failedToLoadReviews": "Échec du chargement de reviews",
    "failedToCreateCycle": "Échec de la création de cycle",
    "failedToSubmitReview": "Échec : submit review",
    "employeeAndAssetTypeAreRequired": "Employé et asset type are requis",
    "failedToCreateAssetRequest": "Échec de la création de asset request",
    "failedToLoadJobs": "Échec du chargement de jobs",
    "applicationFailed": "Échec de application",
    "employeeExpenseTypeDateAndAmountAreRequired": "Employé, expense type, date, et amount are requis",
    "failedToCreateExpense": "Échec de la création de expense",
    "failedToLoadStructures": "Échec du chargement des structures",
    "failedToCreateStructure": "Échec de la création de la structure",
    "assignmentFailed": "Échec de l'affectation",
    "failedToLoadAssignments": "Échec du chargement des affectations salariales",
    "selectDocumentTypeAndFile": "Select document type et file",
    "documentNameIsRequired": "Document name is requis",
    "documentIdNumberIsRequiredForThisType": "Document ID / number is requis pour ce type",
    "expiryDateIsRequiredForThisType": "Expiry date is requis pour ce type",
    "employeeIsRequired": "L'employé est requis",
    "failedToLoadDocumentTypes": "Échec du chargement de document types",
    "uploadFailed": "Échec du téléversement",
    "bankNameAndAccountNumberAreRequired": "Bank name et account number are requis",
    "failedToSaveBankDetails": "Échec de l'enregistrement de bank details",
    "documentFileIsNotAvailable": "Document file is pas disponible",
    "couldNotLoadPreviewOpeningInANew": "Impossible de charger preview — opening in a new tab",
    "failedToLoadDocuments": "Échec du chargement de documents",
    "reportingManagerIsRequired": "Rapporting responsable is requis",
    "anEmployeeCannotBeTheirOwnManager": "An employé cannot be their own responsable",
    "failedToSaveEmploymentDetails": "Échec de l'enregistrement de employment details",
    "codeAndNameAreRequired": "Le code et le nom sont requis",
    "failedToLoadHolidayTypes": "Échec du chargement de holiday types",
    "deactivateFailed": "Échec de la désactivation",
    "activateFailed": "Échec de l'activation",
    "failedToLoadWeekPatterns": "Échec du chargement de week patterns",
    "failedToLoadDevices": "Échec du chargement de devices",
    "registrationFailed": "Échec de registration",
    "failedToLoadHierarchy": "Échec du chargement de hierarchy",
    "failedToLoadEmployeeDetails": "Échec du chargement de employee details",
    "lifecycleUpdateFailed": "Échec de lifecycle update",
    "yourEmployeeProfileIsNotLinkedContactHr": "Your employé profile is pas linked. Contact HR à link votre account.",
    "leaveTypeAndAtLeastOneDayAre": "Le type de congé et au moins un jour sont requis",
    "leaveReasonIsRequired": "Le motif de congé est requis",
    "failedToLoadEmployeeSelfServiceProfile": "Échec du chargement du profil libre-service employé",
    "failedToLoadScheduleAndTimeData": "Échec du chargement de schedule and time data",
    "failedToLoadApprovalRequests": "Échec du chargement de approval requests",
    "failedToLoadLeaveBalances": "Échec du chargement de leave balances",
    "manualCheckOutFailed": "Échec de manual check-out",
    "leaveApplicationFailed": "Échec de leave application",
    "payslipDownloadFailed": "Échec de payslip download",
    "launchFailed": "Échec du lancement",
    "failedToLoadSummary": "Échec du chargement de summary",
    "dateAndNameAreRequired": "Date et name are requis",
    "selectAHolidayTypeConfigureTypesOnThe": "Sélectionnez un type de jour férié — configurez d'abord les types sous Paramètres → Données de référence RH → Types de jours fériés",
    "failedToLoadHolidays": "Échec du chargement de holidays",
    "deleteFailed": "Échec de la suppression",
    "selectAnEmployee": "Sélectionnez un employé",
    "onboardingFailed": "Échec de onboarding",
    "exitInitiationFailed": "Échec de exit initiation",
    "exitFinalizeFailed": "Échec de exit finalize",
    "employeeAndPrincipalAmountAreRequired": "Employé et principal amount are requis",
    "failedToCreateLoanRequest": "Échec de la création de loan request",
    "failedToSaveLeaveType": "Échec de l'enregistrement de leave type",
    "failedToSaveEmploymentType": "Échec de l'enregistrement de employment type",
    "failedToSaveDocumentType": "Échec de l'enregistrement de document type",
    "failedToSaveOvertimeType": "Échec de l'enregistrement du type d'heures supplémentaires",
    "failedToSaveShiftType": "Échec de l'enregistrement de shift type",
    "failedToSaveExpenseType": "Échec de l'enregistrement de expense type",
    "failedToSaveAssetType": "Échec de l'enregistrement de asset type",
    "failedToSavePipelineStage": "Échec de l'enregistrement de pipeline stage",
    "failedToLoadManagerDashboard": "Échec du chargement de manager dashboard",
    "failedToLoadTeamHierarchy": "Échec du chargement de team hierarchy",
    "youDoNotHavePermissionToChangeReporting": "You do pas have permission à change rapporting relationships",
    "employeeAndManagerMustBeDifferent": "Employé et responsable must be different",
    "youDoNotHavePermissionToRemoveReporting": "You do pas have permission à remove rapporting relationships",
    "failedToLoadReportingHierarchy": "Échec du chargement de la hiérarchie de reporting",
    "dateHoursAndOvertimeTypeAreRequired": "La date, les heures et le type d'heures supplémentaires sont requis",
    "overtimeHoursMustBeGreaterThanZero": "Les heures supplémentaires doivent être supérieures à zéro",
    "failedToLoadOvertimeRequests": "Échec du chargement des demandes d'heures supplémentaires",
    "cancelFailed": "Échec de l'annulation",
    "runCodeAndPeriodDatesAreRequired": "Run code et period dates are requis",
    "failedToCreatePayrollRun": "Échec de la création de payroll run",
    "payrollCalculationFailedApproveTheRunFirst": "Paie calculation failed — approve le run first",
    "statutoryExportFailed": "Échec de statutory export",
    "failedToLoadTransactions": "Échec du chargement de transactions",
    "disbursementExportFailed": "Échec de disbursement export",
    "failedToScheduleInterview": "Échec : schedule interview",
    "failedToCompleteInterview": "Échec : complete interview",
    "failedToCreateOffer": "Échec de la création de offer",
    "assessmentFailed": "Échec de assessment",
    "failedToAcceptOffer": "Échec : accept offer",
    "failedToDeclineOffer": "Échec : decline offer",
    "preboardingFailed": "Échec de preboarding",
    "failedToApproveSelection": "Échec : approve selection",
    "failedToApproveOffer": "Échec : approve offer",
    "screeningFailed": "Échec de screening",
    "probationConfirmationFailed": "Échec de probation confirmation",
    "failedToExtendProbation": "Échec : extend probation",
    "bgvUpdateFailed": "Échec de bGV update",
    "failedToLoadWorkQueue": "Échec du chargement de work queue",
    "failedToLoadPipeline": "Échec du chargement de pipeline",
    "failedToLoadJobPostings": "Échec du chargement de job postings",
    "failedToLoadRequisitions": "Échec du chargement de requisitions",
    "failedToLoadManpowerRequests": "Échec du chargement de manpower requests",
    "submitFailed": "Échec de la soumission",
    "failedToCreateJobPosting": "Échec de la création de job posting",
    "failedToCreateRequisition": "Échec de la création de requisition",
    "failedToAddCandidate": "Échec de l'ajout de candidate",
    "failedToCreateManpowerRequest": "Échec de la création de manpower request",
    "failedToLoadAnalytics": "Échec du chargement de analytics",
    "exportFailed": "Échec de l'export",
    "failedToLoadHrSetup": "Échec du chargement de hR setup",
    "failedToLoadHiringPolicy": "Échec du chargement de hiring policy",
    "failedToLoadApprovalPolicy": "Échec du chargement de approval policy",
    "seedFailed": "Échec de l'initialisation",
    "failedToSaveHiringPolicy": "Échec de l'enregistrement de hiring policy",
    "failedToSaveApprovalPolicy": "Échec de l'enregistrement de approval policy",
    "failedToSaveWorkforceSettings": "Échec de l'enregistrement de workforce settings",
    "shiftNameAndTypeAreRequired": "Quart name et type are requis",
    "failedToUpdateShift": "Échec de la mise à jour de shift",
    "shiftAndAtLeastOneDayAreRequired": "Quart et at least one day are requis",
    "failedToLoadShiftAssignments": "Échec du chargement de shift assignments",
    "failedToLoadShifts": "Échec du chargement de shifts",
    "failedToLoadShiftChangeRequests": "Échec du chargement de shift change requests",
    "failedToLoadShiftChangeHistory": "Échec du chargement de shift change history",
    "downloadFailed": "Échec du téléchargement",
    "failedToLoadSuccessionPlans": "Échec du chargement de succession plans",
    "createFailed": "Échec de la création",
    "updateFailed": "Échec de la mise à jour",
    "failedToLoadTrainingCourses": "Échec du chargement de training courses",
    "createCourseFailed": "Échec de create course",
    "assignFailed": "Échec de l'assignation",
    "failedToLoadTravelRequests": "Échec du chargement de travel requests",
    "dateIsRequired": "Date is requis",
    "failedToRemoveOverride": "Échec : remove override",
    "weeklyOtAggregationFailed": "Échec de l'agrégation des HS hebdomadaires",
    "companyWeeklyOtFailed": "Échec des HS hebdomadaires de la société",
    "monthEndFailed": "Échec de month-end",
    "portalFilingFailed": "Échec de la déclaration {{portalCode}}",
    "failedToLoadEmploymentTypes": "Échec du chargement de employment types",
    "failedToLoadExpenseTypes": "Échec du chargement de expense types",
    "failedToLoadLeaveTypes": "Échec du chargement de leave types",
    "failedToLoadOvertimeTypes": "Échec du chargement des types d'heures supplémentaires",
    "failedToLoadShiftTypes": "Échec du chargement de shift types",
    "failedToLoadCourses": "Échec du chargement de courses",
    "failedToLoadAssetRequests": "Échec du chargement de asset requests",
    "failedToLoadExpenseClaims": "Échec du chargement de expense claims",
    "failedToLoadEmployees": "Échec du chargement de employees",
    "failedToLoadLoanRequests": "Échec du chargement de loan requests",
    "failedToLoadPayrollRuns": "Échec du chargement des bulletins de paie",
    "failedToLoadTimesheet": "Échec du chargement de la feuille de temps",
    "failedToLoadTimesheetSummary": "Échec du chargement du récapitulatif de la feuille de temps",
    "failedToPreviewRosterCopy": "Échec de l'aperçu de la copie du planning",
    "failedToCopyRoster": "Échec de la copie du planning",
    "failedToUpdateShiftDay": "Échec de la mise à jour du shift pour ce jour",
    "failedToPublishRoster": "Échec de la publication du planning",
    "receiptRequiredForExpenseType": "Un reçu est requis pour ce type de dépense.",
    "enterSettlementAmount": "Saisissez un montant de règlement."
  },
  "pages": {
    "hrAdmin": "Administration RH",
    "fieldPermissionsCountryPacksShiftRotation": "Field permissions, country packs, quart rotation patterns",
    "noFieldPermissions": "Aucune permission de champ",
    "noCountryPacks": "Aucun pack pays",
    "noShiftRotations": "No quart rotations",
    "performanceAppraisal": "Évaluation de performance",
    "cyclesSelfManagerHrReviewsAnd": "Cycles, self/responsable/HR reviews, et final ratings",
    "assetRequests": "Demandes d'actifs",
    "employeeAssetRequestsWithApprovalWorkflow": "Employé asset requests avec approbation flux de travail",
    "newAssetRequest": "New actif request",
    "submitAssetRequest": "Soumettre la demande",
    "expenseClaims": "Notes de frais",
    "approvedClaimsLoaded": "Notes de frais approuvées (chargées)",
    "pendingClaimsLoaded": "Notes de frais en attente (chargées)",
    "reimbursementsWithApprovalWorkflowAndFinance": "Reimbursements avec approbation flux de travail et finance integration",
    "compensation": "Salaire et avantages",
    "salaryStructuresAndEmployeeAssignments": "Structures salariales et affectations employés",
    "noStructuresYet": "Aucune structure pour le moment",
    "noAssignmentsForThisEmployeeYet": "Aucune affectation pour cet employé pour le moment",
    "selectAnEmployee": "Sélectionnez un employé",
    "expectedHours": "Heures attendues",
    "workedHoursApproved": "Heures travaillées (approuvées)",
    "overtimeApproved": "Heures supplémentaires (approuvées)",
    "employmentType": "Type d'emploi",
    "employmentSummary": "Synthèse de l'emploi",
    "recentAttendance": "Recent présence",
    "recentLeave": "Recent congé",
    "recentExpenses": "Dépenses récentes",
    "employmentDetails": "Détails de l'emploi",
    "lifecycleHistory": "Historique du cycle de vie",
    "employmentHistory": "Historique d'emploi",
    "attendanceHistory": "Présence history",
    "leaveHistory": "Congé history",
    "payrollRuns": "Paie runs",
    "bankDetails": "Coordonnées bancaires",
    "performanceReviews": "Performance avis",
    "employeeDocuments": "Employé documents",
    "training": "Formation",
    "assignedAssets": "Assigned actifs",
    "chooseSomeoneFromTheDirectoryOr": "Choose someone de le directory ou hierarchy à afficher their full HR profile.",
    "lastRecordedDays": "Derniers jours enregistrés",
    "latestLeaveRequests": "Latest congé requests",
    "stageChangesAndHrEvents": "Stage changes et HR events",
    "noAttendanceRecords": "No présence records",
    "noLeaveRecords": "No congé records",
    "noExpenseClaims": "Aucune note de frais",
    "noPayrollRecords": "No paie records",
    "noPerformanceReviews": "No performance avis",
    "attendanceWillAppearHereOnceRecorded": "Présence will appear here once recorded.",
    "leaveRequestsWillAppearHereOnce": "Congé requests will appear here once soumis.",
    "documentPreview": "Aperçu du document",
    "editEmployment": "Modifier l'emploi",
    "assignDepartmentDesignationGradeAndBusiness": "Assign département, designation, grade, et business unit de votre company master data. Create masters under HR → Master data if lists are empty.",
    "goToToday": "Aller à aujourd'hui",
    "noHolidayTypesYet": "No jour férié types yet",
    "workforceDetails": "Détails de l'effectif",
    "candidates": "Candidats",
    "leave": "Congé %",
    "attendanceRecords": "Présence records",
    "workforceTimePayAndTalentScoped": "Workforce, time, pay, et talent — scoped à votre role et rapporting tree",
    "attendanceDevices": "Appareils de présence",
    "biometricRfidQrAndFaceRecognition": "Connecteurs biométriques, RFID, QR et reconnaissance faciale",
    "employeeDirectory": "Répertoire des employés",
    "browseEmployeesExploreReportingHierarchyAnd": "Parcourez les employés, explorez la hiérarchie de reporting et gérez les profils, y compris les documents",
    "employmentAtAGlance": "Vue d'ensemble de l'emploi",
    "leaveBalances": "Congé balances",
    "upcomingRoster": "Planning à venir",
    "recentRoster": "Planning récent",
    "yourRecordsAtAGlance": "Vue d'ensemble de vos dossiers",
    "attendance": "Présence",
    "leaveRequests": "Congé requests",
    "payslips": "Bulletins de paie",
    "myApprovalRequests": "My approbation requests",
    "overtime": "Heures supplémentaires",
    "availableDaysByLeaveType": "Available days by congé type",
    "yourNextScheduledShiftsFromToday": "Your next scheduled quarts de today",
    "lastRosterEntriesForThisMonth": "Last roster entries pour ce month",
    "last5EntriesInEachArea": "Les 5 dernières entrées de chaque zone — tout au même endroit",
    "recentCheckInsAndHours": "Recent check-ins et hours",
    "recentApplicationsAndStatus": "Recent applications et status",
    "recentPayrollRuns": "Recent paie runs",
    "workflowStatusForYourSubmissions": "Flux de travail status pour votre submissions",
    "recentOvertimeRequests": "Demandes d'heures supplémentaires récentes",
    "recentReimbursements": "Remboursements récents",
    "assignedCourses": "Cours attribués",
    "applyForLeave": "Apply pour congé",
    "availableLeave": "Available congé",
    "expectedMonth": "Attendu (mois)",
    "workedApproved": "Travaillé (approuvé)",
    "yourLeaveBalances": "Your congé balances",
    "noLeaveBalancesConfiguredForYourAccount": "Aucun solde de congés configuré pour votre compte.",
    "availableDaysReflectApprovedLeaveUsageOnly": "Les jours disponibles reflètent uniquement les congés approuvés. Les demandes en attente sont affichées séparément et ne réduisent le solde disponible qu'après approbation.",
    "yourProfileScheduleTimeLeavePay": "Votre profil, planning, temps, congés, paie et support RH en un seul endroit",
    "trackLeaveAndOtherHrRequests": "Track congé et other HR requests soumis pour approbation.",
    "downloadPdfPayslipsForProcessedPayroll": "Download PDF payslips pour processed paie runs.",
    "noLeaveHistory": "No congé history",
    "noPayslipsAvailable": "No payslips disponible",
    "submittedLeaveRequestsWillAppearHere": "Submitted congé requests will appear here.",
    "payslipsAppearAfterPayrollIsProcessed": "Payslips appear after paie is processed.",
    "employment": "Emploi",
    "bankDetailsForPayroll": "Bank details pour paie",
    "requiredDocumentTracking": "Requis document tracking",
    "documents": "Documents",
    "assets": "Actifs",
    "leaveSummary": "Congé summary",
    "recentAttendanceOvertime": "Heures supplémentaires récentes (présence)",
    "typesConfiguredWithExpiryTracking": "Types configurerd avec expiry tracking",
    "viewUploadAndDownloadYourHr": "View, upload, et download votre HR documents",
    "companyAssetsAssignedToYou": "Company assets assigned à you",
    "noTrackedDocumentTypesConfigured": "No tracked document types configurerd",
    "noTrainingAssigned": "No formation assigned",
    "noAssetsAssigned": "No actifs assigned",
    "noReviewsYet": "No avis yet",
    "noOvertimeFromAttendance": "Aucune heure supplémentaire issue de la présence",
    "workScheduleOverview": "Work planification overview",
    "shiftAssignments": "Quart assignments",
    "roster": "Planning",
    "workCalendar": "Calendrier de travail",
    "yourAssignedShiftsAndEffectivePeriods": "Your assigned quarts et effective periods",
    "daySpecificShiftOverridesForThis": "Day-specific quart overrides pour ce month",
    "resolvedScheduleIncludingHolidaysAndShift": "Resolved schedule including jour fériés et quart times",
    "noShiftAssignment": "No quart assignment",
    "noRosterEntriesThisMonth": "No roster entries ce month",
    "yourHrTeamAssignsShiftsUnder": "Your HR team assigns quarts under Quarts. Company default calendar applies when none is set.",
    "rosterEntriesAppearWhenYourManager": "Roster entries appear when votre responsable plans a specific quart pour a date.",
    "timeSummary": "Synthèse du temps",
    "expected": "Attendu",
    "missing": "Manquant",
    "overtimeRequests": "Demandes d'heures supplémentaires",
    "thisMonthAtAGlance": "Ce mois-ci en bref",
    "manualOvertimeRequestsSubmittedForApproval": "Demandes manuelles d'heures supplémentaires soumises pour approbation",
    "noOvertimeRequestsThisMonth": "Aucune demande d'heures supplémentaires ce mois-ci",
    "yourCheckInsAndAttendanceWill": "Your check-ins et présence will appear here.",
    "overtimeFromAttendanceIsCalculatedAutomatically": "Les heures supplémentaires issues de la présence sont calculées automatiquement à la sortie.",
    "peerManagerAndSubordinateFeedbackCycles": "Peer, responsable, et subordinate feedback cycles",
    "noFeedbackResponsesYet": "Aucune réponse de feedback pour le moment",
    "publicHolidays": "Public jour fériés",
    "companyCalendarDaysAndCustomizableHoliday": "Company calendar days et customizable jour férié categories pour présence, congé, et schedules",
    "noHolidaysForThisYear": "No jour fériés pour ce year",
    "addHolidaysSoLeaveAndAttendance": "Add jour fériés so congé et présence respect votre company calendar.",
    "onboardingExit": "Intégration et départ",
    "preboardingTasksAndSeparationWorkflow": "Preboarding tasks et separation flux de travail",
    "employeeLoans": "Prêts employés",
    "loanRequestsWithPlatformApprovalWorkflow": "Demandes de prêt avec flux d'approbation plateforme",
    "addALeaveTypeFirstThen": "Add a congé type first, then configurer policies pour paid congé types",
    "noLeaveTypesYetAddYour": "No congé types yet — ajouter votre own",
    "noEmploymentTypesAddFullTime": "No employment types — ajouter Full-time, Contract, Intern, etc.",
    "noDocumentTypesAddPassportVisa": "No document types — ajouter Passport, Visa, Contract, etc.",
    "noOvertimeTypesYetAddTypes": "Aucun type d'heures supplémentaires — ajoutez des types pour jour ouvré, jour férié, week-end, etc.",
    "noShiftTypesYetAddFixed": "No quart types yet — ajouter Fixed, Flexible, Rotational, ou votre own categories",
    "noPipelineStagesDefaultsAreCreated": "No pipeline stages — defaults are créé on first load",
    "noExpenseTypesYetAddTravel": "No expense types yet — ajouter Travel, Meals, Supplies, etc.",
    "noAssetTypesYetAddLaptop": "No asset types yet — ajouter Laptop, Phone, Monitor, etc.",
    "noBusinessUnitsYetAddYour": "No business units yet — ajouter votre company divisions",
    "noDepartmentsYetCreateTeamsEmployees": "No départements yet — create teams employés can be assigned to",
    "noGradesYetDefineJobLevels": "Aucun grade pour le moment — définissez les niveaux de poste (p. ex. G1, G2, Senior)",
    "noDesignationsYetAddJobTitles": "No designations yet — ajouter job titles et link them à grades",
    "yourTeamHierarchyPendingApprovalsAnd": "Votre hiérarchie d'équipe, approbations en attente et actions rapides",
    "reportingHierarchy": "Hiérarchie de reporting",
    "viewAndManageWhoReportsTo": "View et manage who rapports à whom. Départements, designations, grades, et business units are configurerd in HR master data.",
    "noOvertimeRequestsInThisPeriod": "Aucune demande d'heures supplémentaires sur cette période",
    "countryTemplatesSalaryCalculationAndFinance": "Modèles pays, calcul des salaires et intégration comptable GL",
    "assessments": "Évaluations",
    "backgroundVerification": "Vérification des antécédents",
    "probationReview": "Probation avis",
    "stageHistory": "Historique des étapes",
    "scheduleInterview": "Planification interview",
    "completeInterview": "Terminer l'entretien",
    "createOfferLetter": "Créer la lettre d'offre",
    "scheduleAssessment": "Planification assessment",
    "declineOffer": "Refuser l'offre ?",
    "recruitment": "Recrutement",
    "openPositions": "Postes ouverts",
    "candidatesInPipeline": "Candidats in pipeline",
    "interviewsScheduled": "Entretiens planifiés",
    "offersPending": "Offers en attente",
    "preboarding": "Pré-intégration",
    "onboarding": "Intégration",
    "joiningThisMonth": "Joining ce month",
    "pendingRequisitions": "Demandes en attente",
    "pendingManpower": "Effectifs en attente",
    "probationPending": "Probation en attente",
    "avgTimeToHireDays": "Avg time à hire (days)",
    "avgTimeToFillDays": "Avg time à fill (days)",
    "offerAcceptance": "Acceptation des offres %",
    "joiningRatio": "Taux d'arrivée %",
    "onboardingCompletion": "Intégration completion %",
    "probationSuccess": "Réussite de la période d’essai %",
    "totalHired": "Total embauché",
    "totalApplied": "Total des candidatures",
    "pendingInterviews": "Entretiens en attente",
    "pendingFeedback": "Feedback en attente",
    "pendingOffers": "Offres en attente",
    "pendingPreboarding": "Pré-intégration en attente",
    "pendingOnboarding": "Intégration en attente",
    "pendingBgv": "BGV en attente",
    "pendingConfirmations": "Confirmations en attente",
    "searchCandidates": "Rechercher des candidats",
    "newRequisition": "Nouvelle demande de recrutement",
    "newJobPosting": "Nouvelle offre d'emploi",
    "addCandidate": "Ajouter un candidat",
    "newManpowerRequest": "Nouvelle demande de personnel",
    "requisitionPostingPipelineOfferOnboardingEmployee": "Requisition → posting → pipeline → offer → onboarding → employé",
    "noManpowerRequestsCreateOneTo": "No manpower requests — create one à plan headcount",
    "noRequisitionsCreateAPositionRequisition": "No requisitions — create a position requisition à start hiring",
    "noJobPostingsApproveARequisition": "No job postings — approve a requisition et post a job",
    "hrReports": "HR rapports",
    "headcount": "Effectif",
    "attendance2": "Présence %",
    "pendingLeaves": "Pending congés",
    "workforceAnalyticsAndStatutoryExports": "Workforce analytics et statutory exports",
    "generalHrSettings": "General HR paramètres",
    "companyPoliciesForHiringLeaveAttendance": "Company policies pour hiring, congé, présence, approbations, date & time display, et default HR seed data.",
    "noSetupDataYetSeedDefaults": "No setup data yet — seed defaults à populate",
    "editShift": "Edit quart",
    "shifts": "Quarts",
    "timesheet": "Feuille de temps",
    "assignShift": "Assign quart",
    "noShiftAssignments": "No quart assignments",
    "approvedAssignmentsAndPendingShiftChanges": "Approved assignments et en attente quart changes appear here after you submit them.",
    "statutoryFiling": "Déclarations légales",
    "automatedPortalSubmissionEpfoEcrEsic": "Dépôt automatique sur les portails (EPFO ECR, ESIC, TRACES) et liens manuels",
    "successionPlanning": "Planification de la succession",
    "criticalPositionsSuccessorsAndRiskAnalysis": "Critical positions, successors, et risk analysis",
    "noSuccessionPlansYet": "Aucun plan de succession pour le moment",
    "coursesAssignmentsAndCompletionTracking": "Courses, assignments, et completion tracking",
    "travelManagement": "Gestion des déplacements",
    "travelRequestsApprovalAndSettlement": "Travel requests, approbation, et settlement",
    "newTravelRequest": "Nouvelle demande de déplacement",
    "workCalendarsSchedules": "Calendriers et plannings de travail",
    "worked": "Travaillé",
    "dailyOt": "HS journalières",
    "weeklyOt": "HS hebdomadaires",
    "chooseAnEmployeeToViewTheir": "Choisissez un employé pour afficher son calendrier de travail, les dérogations et les heures supplémentaires hebdomadaires du mois sélectionné.",
    "noOverridesThisMonth": "Aucune dérogation ce mois-ci",
    "noWeeklySummariesForThisMonth": "Aucun récapitulatif hebdomadaire pour ce mois-ci",
    "useTheFormAboveOrSwitch": "Utilisez le formulaire ci-dessus ou passez en vue calendrier et cliquez sur un jour pour ajouter une dérogation.",
    "recalculateTheCurrentWeekOrWait": "Recalculez la semaine en cours ou attendez le traitement du dimanche."
  },
  "labels": {
    "reviewer": "Évaluateur",
    "score": "Score",
    "comments": "Commentaires",
    "newCycleName": "Nom du nouveau cycle",
    "fullName": "Nom complet",
    "email": "Email",
    "phone": "Téléphone",
    "structureName": "Nom de la structure",
    "salaryStructure": "Structure salariale",
    "grossAmount": "Montant brut",
    "effectiveFrom": "En vigueur à partir du",
    "effectiveTo": "En vigueur jusqu'au",
    "selectStructure": "Sélectionner une structure",
    "selectOvertimeType": "Sélectionner un type d'heures supplémentaires",
    "overtimeType": "Type d'heures supplémentaires",
    "calendarGranularity": "Granularité du calendrier",
    "loadingSchedule": "Chargement du planning",
    "loadingCalendar": "Chargement du calendrier",
    "documentName": "Document name",
    "documentIdNumber": "Document ID / number",
    "issueDate": "Issue date",
    "expiryDate": "Date d'expiration",
    "expiryDateOptional": "Expiry date (facultatif)",
    "documentFile": "Document file",
    "eGPassportEmiratesId": "e.g. Passport, Emirates ID",
    "enterTheIdShownOnThe": "Saisissez the ID shown on the document",
    "chooseADocumentToUpload": "Choose a document à upload",
    "bankName": "Bank name",
    "branch": "Branch",
    "accountNumber": "Compte number",
    "ifscRoutingCode": "IFSC / routing code",
    "bank": "Bank",
    "account": "Compte",
    "ifscRouting": "IFSC / routing",
    "optional": "Facultatif",
    "department": "Département",
    "designation": "Designation",
    "grade": "Échelon",
    "businessUnit": "Business unit",
    "anyDepartment": "Any département",
    "anyDesignation": "Any designation",
    "anyGrade": "Any grade",
    "anyUnit": "Any unit",
    "manager": "Responsable",
    "loadingEmployeeProfile": "Loading employé profile",
    "employmentType": "Type d'emploi",
    "assetType": "Actif type",
    "lifecycleEvents": "Lifecycle events",
    "eventType": "Event type",
    "effectiveDate": "Effective date",
    "allDepartments": "All départements",
    "allDesignations": "All designations",
    "allGrades": "All grades",
    "allBusinessUnits": "All business units",
    "employeeReportingHierarchy": "Hiérarchie de reporting des employés",
    "code": "Code",
    "name": "Nom",
    "description": "Descriptif",
    "nonWorkingDay": "Journée de congé",
    "eGPub": "e.g. PUB",
    "displayName": "Nom affiché",
    "noFileChosen": "Aucun fichier sélectionné",
    "profileSections": "Profile sections",
    "timeDisplayUnit": "Time display unit",
    "defaultStart": "Default start",
    "defaultEnd": "Default end",
    "eGMf9": "e.g. MF9",
    "mondayFriday": "Monday – Friday",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "deviceName": "Device name",
    "deviceCode": "Device code",
    "employeeDirectoryNavigation": "Navigation du répertoire des employés",
    "searchEmployees": "Membres du reporting",
    "employees": "Employés",
    "loadingHierarchy": "Loading hierarchy",
    "employeeProfileDetails": "Employé profile details",
    "nameCodeOrEmail": "Name, code, ou email",
    "lifecycle": "Cycle de vie",
    "currentShift": "Current quart",
    "leaveDays": "Congé days",
    "loadingSelfServicePortal": "Chargement du portail libre-service",
    "refreshPortalData": "Refresh portal data",
    "employeeCode": "Employé code",
    "reviewee": "Reviewee",
    "cycleId": "Cycle ID",
    "year": "Year",
    "date": "Date",
    "type": "Catégorie",
    "selectType": "Select type",
    "reason": "Motif",
    "leaveType": "Type de congé",
    "policyName": "Policy name",
    "accrual": "Accrual",
    "daysPerPeriod": "Days per period",
    "annualEntitlement": "Annual entitlement",
    "maxConsecutiveDays": "Max consecutive days",
    "maxCarryForward": "Max carry forward",
    "allowBackdatedLeave": "Allow backdated congé",
    "maxBackdatedDays": "Max backdated days",
    "policyActive": "Policy active",
    "paidLeave": "Paid congé",
    "carryForward": "Carry forward",
    "leaveTypeColor": "Congé type color",
    "payrollMode": "Paie mode",
    "defaultHoursDay": "Default hours/day",
    "requiresEndDate": "Requires end date",
    "requiresReturnOnExit": "Requires return on exit",
    "trackExpiryDate": "Track expiry date",
    "applicableDay": "Jour applicable",
    "receiptRequired": "Receipt requis",
    "returnRequired": "Return requis",
    "stageColor": "Stage color",
    "eGAnl": "e.g. ANL",
    "eGFtm": "e.g. FTM",
    "eGPas": "e.g. PAS",
    "eGWot": "e.g. WOT",
    "eGFix": "e.g. FIX",
    "eGTrv": "e.g. TRV",
    "eGPhoneScreen": "e.g. Phone screen",
    "eGScr": "e.g. SCR",
    "levelOrder": "Level order",
    "descriptionOptional": "Description (facultatif)",
    "businessUnitOptional": "Business unit (facultatif)",
    "parentDepartmentOptional": "Parent département (optional)",
    "departmentOptional": "Département (optional)",
    "gradeOptional": "Grade (facultatif)",
    "noBusinessUnit": "No business unit",
    "noParent": "No parent",
    "noDepartment": "No département",
    "noGrade": "No grade",
    "shiftColor": "Quart color",
    "employee": "Employé",
    "hours": "Heures",
    "from": "From",
    "to": "To",
    "runCode": "Run code",
    "countryFormulas": "Country (formulas)",
    "round": "Round",
    "dateTime": "Date & time",
    "score15": "Score (1–5)",
    "feedback": "Feedback",
    "salary": "Salaire",
    "joiningDate": "Joining date",
    "offerMessage": "Offer message",
    "positionTitle": "Position title",
    "location": "Location",
    "numberOfPositions": "Number of positions",
    "jobTitle": "Poste title",
    "positions": "Positions",
    "jobPosting": "Poste posting",
    "source": "Origine",
    "title": "Titre",
    "requestType": "Request type",
    "nameOrEmail": "Name ou email…",
    "eGSalesExecutive": "e.g. Sales Executive",
    "eGChennai": "e.g. Chennai",
    "selectJob": "Select job",
    "eGQ3EngineeringHires": "e.g. Q3 engineering hires",
    "defaultApprovalMode": "Default approbation mode",
    "hrManagersMayAutoApproveLeave": "HR responsables may auto-approve congé filed on behalf of others",
    "newHirePath": "New hire path",
    "fullDay": "Full day",
    "halfDay": "Half day",
    "hourly": "Hourly",
    "maxHourlyLeaveDay": "Max hourly congé / day",
    "multiShiftPerDay": "Multi-quart per day",
    "maxShiftsPerDay": "Max quarts per day",
    "strictPresentAllShifts": "Strict present (all quarts)",
    "defaultTimeDisplay": "Default time display",
    "defaultCalendarView": "Default calendar afficher",
    "shiftName": "Quart name",
    "startTime": "Start time",
    "endTime": "End time",
    "shiftDays": "Quart days",
    "criticalPosition": "Critical position",
    "incumbentEmployee": "Incumbent employé",
    "applyOverrideToEmployees": "Apply override à employés",
    "dayType": "Day type",
    "startOptional": "Start (facultatif)",
    "endOptional": "End (facultatif)",
    "purpose": "Objet",
    "supportingDocumentOptional": "Document justificatif (facultatif)"
  },
  "lifecycleEvents": {
    "confirmed": "Confirmé",
    "promotion": "Promotion",
    "transfer": "Transfert",
    "probation": "Période d'essai",
    "termination": "Licenciement",
    "resignation": "Démission"
  },
  "formActions": {
    "saveOverride": "Enregistrer la dérogation",
    "savePolicy": "Enregistrer la politique",
    "removeManager": "Retirer le manager",
    "saveReportingLine": "Enregistrer la ligne hiérarchique",
    "requestOvertime": "Demander des heures supplémentaires",
    "createRequisition": "Créer une demande de recrutement",
    "createPosting": "Créer une offre d'emploi",
    "addCandidate": "Ajouter un candidat",
    "createManpowerRequest": "Créer une demande",
    "markSelected": "Marquer comme sélectionné",
    "createAndSendOffer": "Créer et envoyer l'offre",
    "scheduleAndComplete": "Planifier et terminer",
    "saveChanges": "Enregistrer les modifications",
    "addHoliday": "Ajouter un jour férié",
    "addType": "Ajouter un type",
    "updatePattern": "Mettre à jour le modèle",
    "createPattern": "Créer un modèle",
    "saveApprovalPolicy": "Enregistrer la politique d'approbation",
    "saveHiringPolicy": "Enregistrer la politique d'embauche"
  },
  "setupPage": {
    "seedDefaults": "Initialiser les valeurs par défaut",
    "snapshotTitle": "Aperçu de la configuration",
    "approvalPolicyTitle": "Politique de flux d'approbation",
    "approvalPolicyDescription": "Gouvernance par entreprise pour les congés, la présence, les achats, la finance et autres approbations",
    "perModuleOverrides": "Dérogations par module",
    "perModuleOverridesHint": "Remplacez le mode par défaut de l'entreprise pour des modules spécifiques. Si ce n'est pas Oui, le mode par défaut ci-dessus s'applique.",
    "onBehalfAutoApproveHint": "Lorsque activé, les utilisateurs avec la permission de gestion des congés RH peuvent soumettre un congé pour un autre employé et il est approuvé immédiatement sans instance de flux.",
    "hiringPolicyTitle": "Politique d'embauche",
    "hiringPolicyDescription": "Contrôlez si les nouveaux employés doivent passer par le recrutement ou peuvent être ajoutés directement",
    "forCompany": " pour {{company}}",
    "companySuffix": " — {{company}}",
    "hiringModes": {
      "recruitment": {
        "label": "Recrutement uniquement (recommandé)",
        "description": "Les nouvelles embauches doivent passer par RH → Recrutement → Embauche. Bloque l'ajout direct d'employé."
      },
      "direct": {
        "label": "Autoriser la création directe d'employé",
        "description": "Les RH peuvent ajouter des employés depuis Administration → Employés sans le flux ATS."
      }
    },
    "workflowModes": {
      "flexible": {
        "label": "Flexible (recommandé)",
        "description": "Les soumissions de congés, présence, achats et finance fonctionnent immédiatement. Les boutons d'approbation n'apparaissent que lorsque vous configurez des flux dans Approbations."
      },
      "strict": {
        "label": "Exiger des flux configurés",
        "description": "Les soumissions sont bloquées jusqu'à ce qu'un flux d'approbation soit configuré pour ce module. À utiliser lorsque la gouvernance doit être appliquée."
      }
    },
    "modules": {
      "HR": "RH (congés, présence, paie, …)",
      "PROCUREMENT": "Achats",
      "FINANCE": "Finances",
      "INVENTORY": "Inventaire",
      "CRM": "CRM",
      "DESK": "Support",
      "POS": "PDV",
      "WAREHOUSE": "Entrepôt"
    },
    "workforce": {
      "loading": "Chargement des paramètres de congés et de présence…",
      "savedToast": "Paramètres de congés et de présence enregistrés",
      "leaveModesTitle": "Modes de demande de congé",
      "leaveModesDescription": "Configurer les types de durée de congé et les règles de présence par quart",
      "leaveSection": "Congés",
      "leaveSectionHint": "Quels types de durée de congé les employés peuvent demander et limites horaires.",
      "shiftSection": "Quart",
      "shiftSectionHint": "Présence multi-quarts et évaluation du statut présent sur les quarts.",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "multiShiftDisabled": "Désactivé (quart unique)",
      "anyShiftPresent": "N'importe quel quart présent",
      "allShiftsRequired": "Tous les quarts requis",
      "mobileAttendanceTitle": "Présence mobile et géolocalisée",
      "mobileAttendanceHint": "Contrôler la liaison d'appareil et l'application du périmètre géographique pour le pointage en libre-service.",
      "requireMobileBinding": "Exiger la liaison d'un appareil mobile",
      "requireGeoAttendance": "Exiger la présence géolocalisée",
      "strictGeoFence": "Périmètre géographique strict",
      "strictGeoBlock": "Bloquer hors périmètre",
      "strictGeoFlag": "Autoriser mais signaler",
      "calendarDefaultsTitle": "Paramètres par défaut du calendrier de présence",
      "calendarDefaultsDescription": "Unités de temps et zoom du calendrier par défaut à l'ouverture de Présence. Les utilisateurs peuvent toujours changer de vue pendant leur session.",
      "saveLeaveModes": "Enregistrer les modes de demande de congé",
      "saveMobileAttendance": "Enregistrer la présence mobile et géolocalisée",
      "saveCalendarDefaults": "Enregistrer les paramètres du calendrier",
      "leaveModesSavedToast": "Modes de demande de congé enregistrés",
      "mobileAttendanceSavedToast": "Paramètres de présence mobile et géolocalisée enregistrés",
      "calendarDefaultsSavedToast": "Paramètres par défaut du calendrier de présence enregistrés",
      "saveSettings": "Enregistrer les paramètres de congés et de présence",
      "laborRulesTitle": "Règles temps, heures sup. et paie",
      "laborRulesDescription": "Activez les règles avancées pour le contingent d'heures supplémentaires, les repos compensateurs (RCR/RCO), les majorations jour férié, les indemnités repas et les instantanés de feuille de temps en clôture mensuelle.",
      "saveLaborRules": "Enregistrer les règles du travail",
      "laborRulesSavedToast": "Règles du travail enregistrées",
      "laborRules": {
        "enabled": "Activer les règles du travail",
        "enabledLabel": "Utiliser les règles avancées temps et paie pour cette société",
        "enabledHint": "Si activé, les feuilles de temps appliquent majorations fériées, congés payés comptés comme travaillés, suivi du contingent d'heures sup. et acquisition RCR/RCO selon les paramètres ci-dessous. Les indemnités sont configurées dans Rémunération et avantages.",
        "contingentHours": "Contingent annuel d'heures sup. (heures)",
        "contingentWarningPercent": "Alerte contingent (%)",
        "rcrMode": "Mode d'acquisition RCR",
        "rcoMandatory": "RCO obligatoire après contingent",
        "holidayPremiumRate": "Taux de majoration jour férié par défaut",
        "solidarityDay": "Journée de solidarité",
        "timesheetSnapshots": "Conserver les instantanés journaliers à la clôture mensuelle",
        "rcrModes": {
          "payOnly": "Paiement uniquement",
          "replace": "Remplacer par RCR",
          "split": "Répartir paiement et RCR"
        }
      }
    }
  },
  "shiftsPage": {
    "assignEmployeeHint": "Attribuez le même quart à un ou plusieurs employés.",
    "selectDaysHint": "Cliquez ou faites glisser sur les jours à sélectionner. Seuls les jours choisis s'appliquent à ce quart.",
    "copySchedule": "Copier le planning",
    "copyScheduleTitle": "Copier le planning",
    "copyScheduleHint": "Choisissez quoi copier et où coller. Les shifts copiés apparaissent sur le calendrier en brouillon. Publiez quand le planning est finalisé.",
    "copySourceLabel": "Copier depuis",
    "copySourceVisibleWeek": "Semaine affichée",
    "copySourceVisibleMonth": "Mois affiché",
    "copySourceSingleDay": "Jour unique",
    "copySourceWeekNumber": "Numéro de semaine",
    "copySourceMonth": "Mois",
    "copySourceCustomRange": "Plage de dates personnalisée",
    "copySourceDay": "Jour source",
    "copyRangeFrom": "Du",
    "copyRangeTo": "Au",
    "copyWeekNumber": "Numéro de semaine",
    "copyMonth": "Mois",
    "copyYear": "Année",
    "copyTargetLabel": "Coller vers",
    "copyTargetNextDay": "Jour suivant (+1 jour)",
    "copyTargetNextWeek": "Semaine suivante (+7 jours)",
    "copyTargetNextMonth": "Mois suivant (+1 mois)",
    "copyTargetSpecificDate": "Date de début précise",
    "copyTargetStartDate": "Date de début cible",
    "copyTargetStartDateHint": "Le premier jour source correspond à cette date. Ex. : copier le 6 juin vers le 8 juin.",
    "copyTargetWeekNumber": "Numéro de semaine cible",
    "copyTargetMonth": "Mois cible",
    "copyRangePreview": "Copier {{sourceFrom}} → {{sourceTo}} vers le {{targetFrom}}",
    "copyTargetMode_NEXT_DAY": "jour suivant",
    "copyTargetMode_NEXT_WEEK": "semaine suivante",
    "copyTargetMode_NEXT_MONTH": "mois suivant",
    "copyTargetMode_CUSTOM": "date personnalisée",
    "copyToNextWeek": "Copier vers la semaine suivante",
    "copyWeekTitle": "Salariés",
    "copyWeekHint": "Copier le planning de la semaine affichée vers la semaine suivante.",
    "copyWeekScopeAll": "Tous les salariés avec des shifts dans la plage source",
    "copyWeekScopeSelected": "Salariés sélectionnés uniquement",
    "copyWeekSelectEmployees": "Salariés à copier",
    "copyWeekEmployeesRequired": "Sélectionnez au moins un salarié",
    "copyWeekEmployeesHint": "Seuls les salariés ayant des shifts dans la plage source sont copiés.",
    "copyPreviewTitle": "Confirmer la copie du planning",
    "copyPreviewSummary": "{{count}} affectation(s) seront copiées. {{conflicts}} conflit(s) détecté(s).",
    "copyNothingToStage": "Aucun shift à copier pour la plage sélectionnée.",
    "draftSchedule": "Brouillon (non publié)",
    "editDraftShift": "Modifier ce jour (brouillon)",
    "editDraftShiftHint": "Les modifications sont enregistrées immédiatement. Publiez quand le planning est finalisé.",
    "clearDraftShift": "Effacer le jour",
    "publish": "Publier",
    "expectedColumn": "Prévu",
    "calendarHint": "Cliquez sur un jour pour voir les détails, modifier les shifts brouillon, les approbations en attente ou attribuer un nouveau quart. Après une copie, vérifiez la semaine brouillon puis utilisez Publier pour l'enregistrer.",
    "noEmployeesInScope": "Aucun employé dans votre périmètre de visibilité."
  },
  "timesheetPage": {
    "title": "Feuille de temps",
    "description": "Heures travaillées mensuelles, congés, absences et données paie par salarié.",
    "selectEmployeeHint": "Sélectionnez un salarié pour afficher sa feuille de temps.",
    "summary": {
      "worked": "Heures travaillées",
      "effective": "Effectif travaillé",
      "overtime": "Heures supplémentaires",
      "absenceDays": "Jours d'absence",
      "paidLeaveWorked": "Congés payés comptés comme travaillés",
      "manual": "Pointage manuel",
      "holidayPremium": "Majoration jour férié"
    },
    "badges": {
      "leave": "Congé",
      "absence": "Absence",
      "manual": "Manuel",
      "solidarity": "Solidarité"
    },
    "tooltip": {
      "worked": "Travaillé {{value}}",
      "expected": "Prévu {{value}}",
      "leave": "Congé : {{type}}",
      "absence": "Absence : {{code}}",
      "manual": "Pointage manuel",
      "holidayWorked": "Jour férié travaillé",
      "solidarity": "Journée de solidarité",
      "premium": "Majoration {{value}}"
    }
  },
  "workforcePage": {
    "tabs": {
      "employee": "Planning employé",
      "company": "Modèles société et lots"
    },
    "dayTypes": {
      "WORKING": "Jour ouvré",
      "WEEKEND": "Week-end",
      "HOLIDAY": "Jour férié",
      "HALF_DAY": "Demi-journée",
      "SPECIAL": "Jour spécial"
    },
    "toast": {
      "overrideSaved": "Dérogation calendrier enregistrée"
    },
    "empty": {
      "selectEmployeeForOverride": "Sélectionnez un employé à afficher ou choisissez des employés pour une dérogation groupée"
    },
    "bulkOverrideHint": "Laissez vide pour n'appliquer qu'à l'employé sélectionné ci-dessus. Sélectionnez plusieurs pour une modification groupée.",
    "employeeSchedule": "Planning employé",
    "shiftSummary": "Quart : {{shift}} · {{days}} jours ouvrés · {{hours}}/jour",
    "defaultPattern": "Modèle par défaut",
    "workCalendarHint": "Cliquez sur un jour pour le modifier. Les dérogations priment sur le calendrier société et les jours fériés.",
    "weeklyOvertime": "Heures supplémentaires hebdomadaires",
    "recalculateCurrentWeek": "Recalculer la semaine en cours",
    "weekPatternTemplates": "Modèles de semaine",
    "weekPatternTemplatesHint": "Modèles de semaine de travail réutilisables pour la société active. Attribuez un modèle sous Org → Sociétés → onglet Calendrier.",
    "batchOperations": "Opérations par lots",
    "batchOperationsHint": "Lancez les traitements à l'échelle de la société. La clôture mensuelle alimente la paie et les résumés de présence du mois en cours.",
    "runMonthEnd": "Lancer la clôture mensuelle"
  },
  "holidaysPage": {
    "companyWorkCalendar": "Calendrier de travail de l'entreprise",
    "infoBanner": "Les jours fériés s'appliquent à l'<strong>entreprise active</strong> dans le sélecteur d'en-tête. Configurez les jours ouvrables sous Administration → Entreprises → Calendrier. Gérez les catégories sur l'onglet <strong>Types de jours fériés</strong> de cette page.",
    "laborRulesHint": "Le traitement feuille de temps et le taux de majoration s'appliquent lorsque les règles avancées sont activées (Configuration RH → Politique workforce). Choisissez Jour férié travaillé si des salariés peuvent travailler ce jour avec majoration ; Journée de solidarité pour le suivi dédié.",
    "tabs": {
      "calendar": "Calendrier des jours fériés",
      "types": "Types de jours fériés"
    },
    "holidayCount": "{{count}} jour(s) férié(s) en {{year}}",
    "noTypesWarning": "Aucun type de jour férié actif pour cette entreprise.",
    "addTypesLink": "Ajouter des types de jours fériés",
    "addTypesSuffix": "avant de créer des entrées au calendrier.",
    "editHoliday": "Modifier le jour férié",
    "addHoliday": "Ajouter un jour férié",
    "editHolidayType": "Modifier le type de jour férié",
    "addHolidayType": "Ajouter un type de jour férié",
    "nonWorkingYes": "Oui — établissement / planning fermé",
    "nonWorkingNo": "Non — jour observé (facultatif / travaillé)",
    "cancelEdit": "Annuler la modification",
    "typesDescription": "Définissez les catégories de jours fériés utilisées par votre entreprise (ex. public, régional, facultatif). Lors de l'ajout d'un jour férié dans l'onglet calendrier, choisissez l'un de ces types. Désactivez les types inutiles au lieu de les supprimer.",
    "treatmentLabel": "Traitement feuille de temps",
    "premiumRateLabel": "Taux de majoration (optionnel)",
    "premiumRatePlaceholder": "ex. 1,5 — défaut société si vide",
    "columns": {
      "treatment": "Traitement",
      "premiumRate": "Taux majoration"
    },
    "treatment": {
      "off": "Journée de congé",
      "worked": "Jour férié travaillé (majoration si présence)",
      "solidarity": "Journée de solidarité"
    }
  },
  "leaveBehavior": {
    "title": "Comportement feuille de temps et paie",
    "description": "Impact de ce type de congé sur les heures travaillées, la planification, les indemnités repas et les banques RCR/RCO.",
    "countsAsWorkedHours": "Compte comme heures travaillées",
    "countsAsWorkedHoursHint": "Les minutes de congé payé comptent dans le temps effectif travaillé.",
    "countsTowardOvertimeThreshold": "Compte pour le seuil d'heures sup.",
    "generatesMealAllowance": "Génère une indemnité repas",
    "deductsFromLeaveBalance": "Déduit du solde de congés",
    "blocksScheduling": "Bloque la planification des quarts",
    "requiresDocument": "Justificatif requis",
    "isCompensatoryRest": "Congé de repos compensateur",
    "isCompensatoryRestHint": "À l'approbation, débite la banque RCR ou RCO sélectionnée.",
    "restBankType": "Banque à débiter",
    "restBankPlaceholder": "Choisir la banque",
    "restBank": {
      "rcr": "RCR — repos compensateur",
      "rco": "RCO — repos hors contingent"
    },
    "premiumPayEligible": "Éligible à la majoration"
  },
  "compRest": {
    "title": "Soldes repos compensateurs",
    "description": "Banques d'heures RCR et RCO pour {{year}}. Les crédits viennent des heures sup. approuvées ; les débits des congés de repos compensateur.",
    "rcrBalance": "Solde RCR",
    "rcoBalance": "Solde RCO",
    "noTransactions": "Aucun mouvement RCR/RCO",
    "noTransactionsHint": "Approuvez des heures sup. (avec acquisition RCR) ou posez un congé repos compensateur pour voir l'activité ici.",
    "columns": {
      "date": "Date",
      "bank": "Banque",
      "type": "Catégorie",
      "change": "Variation",
      "balance": "Solde",
      "reason": "Motif"
    },
    "errors": {
      "loadFailed": "Impossible de charger les soldes repos compensateurs"
    }
  },
  "adminPage": {
    "fieldPermissions": "Permissions des champs",
    "countryPacks": "Packs pays",
    "shiftRotations": "Rotations de quarts"
  },
  "weekPatterns": {
    "description": "Créez des modèles de semaine spécifiques à l'entreprise. Assignez-en un au calendrier de travail — aucun préréglage fixe requis.",
    "editTitle": "Modifier le modèle de semaine",
    "newTitle": "Nouveau modèle de semaine",
    "daysHeading": "Jours (1 = lundi)",
    "applyDefaults": "Appliquer les horaires par défaut aux jours ouvrables",
    "savedPatterns": "Modèles enregistrés",
    "columns": {
      "day": "Jour",
      "working": "Ouvrable",
      "halfDay": "Demi-journée",
      "start": "Début",
      "end": "Fin"
    },
    "weekdays": {
      "1": "Lundi",
      "2": "Mardi",
      "3": "Mercredi",
      "4": "Jeudi",
      "5": "Vendredi",
      "6": "Samedi",
      "7": "Dimanche"
    }
  },
  "workflowStatus": {
    "pending": "En attente d'approbation",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "returned": "Renvoyé pour modification"
  },
  "approvalRow": {
    "cancellationPending": "Annulation en attente d'approbation",
    "cancellationPendingShort": "annulation en attente",
    "hideEdit": "Masquer la modification",
    "hideApproval": "Masquer l'approbation",
    "approvalAndHistory": "Approbation et historique"
  },
  "listActions": {
    "submit": "Soumettre",
    "postJob": "Publier l'offre",
    "scheduleInterview": "Planifier un entretien",
    "createOffer": "Créer une offre",
    "createCycle": "Créer un cycle",
    "createPlan": "Créer un plan",
    "createStructure": "Créer une structure",
    "assignSalary": "Assigner un salaire",
    "submitRequest": "Soumettre la demande",
    "startOnboarding": "Démarrer l'intégration",
    "initiateExit": "Initier la sortie",
    "finalizeExit": "Finaliser la sortie",
    "launch360": "Lancer le 360",
    "viewSummary": "Voir le résumé",
    "registerDevice": "Enregistrer l'appareil",
    "submitApplication": "Soumettre la candidature",
    "settle": "Régler",
    "cancel": "Annuler"
  },
  "messages": {
    "uploadTravelSupportingFile": "Téléversez l'itinéraire, la lettre d'invitation ou un autre justificatif."
  },
  "reports": {
    "filterTitle": "Période du rapport",
    "dateRangeInvalid": "La date de début doit être antérieure ou égale à la date de fin",
    "dualSheetHint": "Les exports Excel incluent le détail et une synthèse par employé (heures et jours). Sélectionnez un employé pour son rapport hebdomadaire ou mensuel. Les données respectent votre visibilité hiérarchique.",
    "workforceSection": "Rapports effectifs",
    "otherSection": "Autres rapports",
    "allRecords": "Tous les enregistrements",
    "allEmployees": "Tous les employés",
    "employeeFilter": "Employé",
    "employeeFilterPlaceholder": "Tous les employés de votre périmètre",
    "periodMonth": "Ce mois",
    "periodWeek": "Cette semaine",
    "periodCustom": "Période personnalisée",
    "formats": {
      "CSV": "CSV",
      "EXCEL": "Excel"
    },
    "tabs": {
      "exports": "Exports standards",
      "payrollHandoff": "Export paie"
    },
    "payrollHandoff": {
      "title": "Transmission paie",
      "description": "Vérifiez la préparation paie, les indemnités dynamiques, les dépenses approuvées, les demandes, la présence, les feuilles de temps et l'aperçu de paie avant génération.",
      "year": "Année",
      "month": "Mois",
      "employeeId": "ID employé",
      "downloadCsv": "Télécharger le CSV",
      "downloadExcel": "Télécharger Excel",
      "invalidPeriod": "Saisissez une année et un mois valides",
      "employeesReady": "Employés prêts",
      "payrollExceptions": "Exceptions paie",
      "totalPayrollCost": "Coût total paie",
      "reimbursementCost": "Coût dépenses et demandes",
      "allowanceCost": "Coût indemnités",
      "expenseCost": "Coût dépenses",
      "claimCost": "Coût demandes",
      "attendanceSummary": "Synthèse présence",
      "workedDays": "Travaillé",
      "leaveDays": "Congé",
      "overtime": "Heures sup.",
      "lateHours": "Retard",
      "payrollComponents": "Composants paie",
      "basicSalary": "Salaire de base",
      "variableEarnings": "Gains variables",
      "deductions": "Déductions",
      "netPayPreview": "Aperçu net à payer",
      "allowances": "Indemnités",
      "expenses": "Dépenses",
      "claims": "Demandes",
      "validations": "Validations",
      "none": "Aucun",
      "noEmployees": "Aucun employé trouvé pour cette période de paie."
    },
    "types": {
      "ATTENDANCE": "Présence",
      "LEAVE": "Congés",
      "OVERTIME": "Heures supplémentaires",
      "SCHEDULE_COMPLIANCE": "Conformité des horaires",
      "PAYROLL_READINESS": "Préparation de la paie",
      "PAYROLL": "Paie",
      "ALLOWANCE_SUMMARY": "Synthèse des indemnités",
      "ALLOWANCE_BY_TYPE": "Indemnités par type",
      "ALLOWANCE_BY_DEPARTMENT": "Indemnités par département",
      "EXPENSE_SUMMARY": "Synthèse des dépenses",
      "CLAIM_SUMMARY": "Synthèse des demandes",
      "PAYROLL_EXCEPTIONS": "Exceptions paie",
      "PENDING_APPROVALS": "Approbations en attente",
      "PAYROLL_VARIANCE": "Écart paie",
      "PAYROLL_COST_ANALYSIS": "Analyse des coûts paie",
      "RECRUITMENT": "Recrutement",
      "TRAINING": "Formation",
      "PERFORMANCE": "Performance",
      "ATTRITION": "Attrition",
      "EMPLOYMENT_HISTORY": "Historique d'emploi"
    }
  },
  "import": {
    "title": {
      "attendance": "Import CSV en masse — Présence",
      "shifts": "Import CSV en masse — Équipes",
      "overtime": "Import CSV en masse — Heures supplémentaires"
    },
    "description": {
      "attendance": "Téléversez les heures d'entrée et de sortie. Le système calcule les heures travaillées, attendues et les heures sup. avant l'import.",
      "shifts": "Téléversez les affectations d'équipe par date. Les lignes sont soumises pour approbation comme les changements manuels.",
      "overtime": "Téléversez des demandes d'heures sup. autonomes (heures ou minutes) pour les employés de votre périmètre de visibilité."
    },
    "steps": "1. Télécharger le modèle CSV · 2. Remplir vos lignes · 3. Téléverser le fichier pour validation · 4. Importer les lignes valides",
    "expand": "Développer la section",
    "collapse": "Réduire la section",
    "downloadSample": "Télécharger le modèle CSV",
    "downloadSampleHint": "Télécharger un modèle CSV avec les en-têtes de colonnes adaptés à votre langue",
    "selectFile": "Téléverser un fichier CSV",
    "validating": "Validation…",
    "selectedFile": "Sélectionné : {{name}}",
    "emptyCell": "—",
    "emptyPreview": "Aucune ligne à prévisualiser",
    "summary": "{{valid}} valide(s), {{errors}} erreur(s), {{warnings}} avertissement(s) — corrigez les erreurs ou importez uniquement les lignes valides.",
    "importAll": "Tout importer ({{count}} lignes)",
    "importValidOnly": "Importer les lignes valides uniquement ({{count}})",
    "templateFilenames": {
      "attendance": "modele-import-presence.csv",
      "shifts": "modele-import-equipes.csv",
      "overtime": "modele-import-heures-sup.csv"
    },
    "columns": {
      "row": "Ligne",
      "employeeCode": "Code employé",
      "status": "Statut",
      "messages": "Messages"
    },
    "status": {
      "valid": "Valide",
      "error": "Erreur",
      "warning": "Avertissement"
    },
    "preview": {
      "checkIn": "Entrée",
      "checkOut": "Sortie",
      "workedHours": "Travaillées (h)",
      "expectedHours": "Attendues (h)",
      "overtimeHours": "H. sup. (h)",
      "overtimeType": "Type h. sup.",
      "lateMinutes": "Retard (min)",
      "assignmentDate": "Date",
      "shiftName": "Équipe",
      "overtimeDate": "Date",
      "hours": "Heures"
    },
    "errors": {
      "fileRequired": "Sélectionnez d'abord un fichier CSV.",
      "templateDownloadFailed": "Impossible de télécharger le modèle CSV.",
      "validationFailed": "Échec de la validation CSV.",
      "importFailed": "Échec de l'import CSV."
    },
    "toast": {
      "templateDownloaded": "Modèle CSV téléchargé.",
      "validated": "{{count}} ligne(s) validée(s). Vérifiez l'aperçu avant d'importer.",
      "imported": "{{count}} ligne(s) importée(s) avec succès.",
      "partialFailure": "{{count}} ligne(s) n'ont pas pu être importées — consultez le tableau d'aperçu.",
      "noRowsImported": "Aucune ligne importée. Corrigez les erreurs et réessayez."
    }
  }
}
